{
  "accountDropdown": {
    "changeAccount": "Cambia account",
    "filter": "Filtro",
    "loading": "Caricamento in corso",
    "profile": "Profilo",
    "searchHotelPlaceholder": "Cerca hotel...",
    "title": "Account"
  },
  "action": {
    "decrease": "Diminuisci",
    "delete": "Elimina",
    "duplicate": "Duplica",
    "increase": "Aumenta",
    "rename": "Rinomina",
    "save": "Salva",
    "saveChanges": "Salva modifiche",
    "setAsDefault": "Imposta come predefinito"
  },
  "activated": "Attivata",
  "activityLog": {
    "affectedDate": "Data ricercata",
    "affectedDateTooltip": "Impostare il tempo di modifica su “Ultimi 6 mesi“, per visualizzare tutte le modifiche registrate per la data selezionata.",
    "changeTime": "Periodo di modifica",
    "details": "Dettagli",
    "emptyTable": "Non ci sono elementi da visualizzare, provare ad aumentare l'intervallo di date ”Ora di modifica” per visualizzare più risultati.",
    "filenamePrefix": "activity-log",
    "loggedDatesTooltip": "In base alle norme sulla protezione dei dati, i registri vengono eliminati dopo 6 mesi.",
    "maxExportElementsReached": "Troppi elementi selezionati. Si prega di modificare i filtri per ridurre la selezione a meno di {max} elementi prima di esportare.",
    "ranges": {
      "last3Months": "Ultimo 3 mesi",
      "last6Months": "Ultimo 6 mesi",
      "last7Days": "Ultimi 7 giorni",
      "lastMonth": "Ultimo mese",
      "thisMonth": "Questo mese"
    },
    "schemaMapping": {
      "rateRulesV1": {
        "activate": "La regola tariffaria \"{name}\" è stata attivata.",
        "deactivate": "La regola tariffaria \"{name}\" è stata disattivata.",
        "delete": "La regola tariffaria \"{name}\" è stata cancellata",
        "edit": "La regola tariffaria \"{name}\" è stata modificata."
      },
      "ratesV1": {
        "rateFromTo": "da {rateFrom} a {rateTo}",
        "rateTo": "a {rateTo}"
      },
      "restrictionsV1": {
        "ctaAdded": "CTA aggiunto",
        "ctaRemoved": "CTA cancellato",
        "ctdAdded": "CTD aggiunto",
        "ctdRemoved": "CTD cancellato",
        "maxLos": "MaxLOS cancellato | MaxLOS a {n} | MaxLOS a {n}",
        "minLos": "MinLOS cancellato | MinLOS a {n} | MinLOS a {n}"
      },
      "resyncdataV1": {
        "error": "Le tariffe e le restrizioni non sono state sincronizzate. Ulteriori dettagli sono disponibili nel registro errori sulla pagina Gestione",
        "success": "Le tariffe e le restrizioni sono state sincronizzate con successo per i prossimi 24 mesi.",
        "trigger": "La risincronizzazione è stata avviata. Il completamento del processo sarà registrato tra pochi minuti."
      }
    },
    "title": "Registro attività",
    "tooManyLogs": "{numero} da mostrare. Si prega di specificare la data ricercata!",
    "type": "Tipologia di modifica",
    "types": {
      "rateRules": "Rate Rules",
      "rates": "Tariffe",
      "restrictions": "Restrizioni",
      "resyncdata": "Resync"
    },
    "typesPerContent": {
      "resyncdataV1": {
        "error": "Resync - errore",
        "success": "Resync - successo",
        "trigger": "Resync - trigger"
      }
    },
    "user": "Utente"
  },
  "add": "Aggiungi",
  "administration": {
    "inboundData": {
      "applyFilter": "Applica filtro",
      "arrival": "Arrivo",
      "booked": "Booked",
      "cancelled": "Cancelled",
      "comparison": {
        "downloadTemplate": "Scarica Il Modello",
        "error": {
          "dateParsingError": "Impossibile leggere {count} valori di data. Controlla i tuoi dati e riprova.",
          "generic": "Impossibile caricare i risultati del confronto. Riprova più tardi."
        },
        "instructions": {
          "fields": "Data, Revenue, Camere vendute.",
          "intro": "Prima di caricare il file, tieni presente quanto segue:",
          "maxFileSize": "La dimensione massima del file è di 10 MB.",
          "requiredFields": "Il tuo file .csv o .xlsx deve contenere i campi",
          "revenueFormat": "I ricavi devono essere indicati nello stesso formato specificato nel modello sottostante."
        },
        "loading": "Caricamento dei risultati del confronto…",
        "startNewComparison": "Avvia nuovo confronto",
        "step1": {
          "message": "Carica il tuo file."
        },
        "step2": {
          "compare": "Confronta",
          "excludedRooms": "Camere escluse",
          "header": "L'intestazione è contenuta nel file",
          "message": "Assegnare tutti i campi richiesti.",
          "notMapped": "Non mappato",
          "settings": "Impostazioni"
        },
        "table": {
          "date": "Data",
          "pmsRevenue": "PMS Revenue",
          "pmsRoomsSold": "PMS Camere vendute",
          "rbRevenue": "RB Revenue",
          "rbRoomsSold": "RB Camere vendute",
          "revenueDiff": "Revenue Diff.",
          "roomsSoldDiff": "Camere vendute Diff."
        }
      },
      "confirmed": "Confirmed",
      "creation": "Creazione",
      "dataTableColumnTitle": {
        "arrivalDate": "Data di arrivo",
        "blockedUntil": "Bloccato fino al",
        "blockId": "Blocca l'ID",
        "channel": "Channel",
        "countryCode": "Codice paese",
        "creationDate": "Data di creazione",
        "departureDate": "Data di partenza",
        "excluded": "Esclusi",
        "isRoom": "È la camera",
        "mainResId": "Principale ResID",
        "name": "Nome",
        "numberOfAdults": "Numero adulti",
        "numberOfChildren": "Numero bambini",
        "numberOfInfants": "Numero neonati",
        "reservationId": "ID esterno prenotazione",
        "roomNumber": "Numero di camera",
        "roomType": "Tipo di camera",
        "segment": "Segmento",
        "status": "Stato",
        "total": "Totale"
      },
      "dataTabs": {
        "roomStats": {
          "description": "Room stats re-computation",
          "recompute": "Re-compute"
        },
        "title": {
          "blocks": "Blocchi",
          "comparison": "Confronta le prenotazioni",
          "inventory": "Inventario",
          "reservations": "Prenotazioni",
          "roomStats": "Room Stats"
        }
      },
      "delete": "Elimina",
      "deleteAll": "Tutti",
      "deleteFiltered": "Filtrati",
      "deleteSelected": "Selezionati",
      "departure": "Partenza",
      "filterDropdown": {
        "noneSelected": "Nessuno",
        "selected": "{count} selezionati"
      },
      "filters": {
        "blockId": "Blocca l'ID",
        "dateBy": "Filtra le date per",
        "dateRange": "Intervallo di date",
        "excludedRooms": "Esclusi",
        "filter": "Filtro",
        "reservationId": "ID della prenotazione",
        "roomType": "Tipo di stanza",
        "status": "Stato"
      },
      "hide": "Nascondi",
      "inboundData": "Dati in ingresso",
      "inventory": {
        "blocked": "Bloccato (blocco disponibile)",
        "date": "Data",
        "excluded": "Escluso",
        "outOfOrder": "Fuori servizio",
        "physical": "Fisico",
        "roomType": "Tipo di camera"
      },
      "modal": {
        "cleanAll": {
          "message": "Per eliminare le prenotazioni, digita il seguente testo nel campo di input qui sotto: {companyName}",
          "title": "Elimina prenotazioni"
        },
        "cleanFiltered": {
          "message": {
            "blocks": "Siete sicuri di voler eliminare i blocchi selezionati? Ciò comporterà la cancellazione di tutte le blocchi che corrispondono ai filtri impostati.",
            "reservations": "Sei sicuro di cancellare le prenotazioni filtrate? Ciò comporterà la cancellazione di tutte le prenotazioni che corrispondono ai filtri impostati, comprese tutte le camere"
          },
          "title": {
            "blocks": "Blocchi vuote",
            "reservations": "Prenotazioni vuote"
          }
        },
        "cleanSelected": {
          "message": {
            "blocks": "Siete sicuri di voler eliminare i blocchi selezionati?",
            "reservations": "Siete sicuri di voler eliminare le prenotazioni selezionate?"
          },
          "title": {
            "blocks": "Vuore le ostruzioni",
            "reservations": "Prenotazioni vuote"
          }
        }
      },
      "noShow": "No Show",
      "option": "Option",
      "optionNoDeduction": "Option no deduction",
      "reservationsImport": {
        "addToDatabase": "Aggiungi al database",
        "cancelImport": "Interrompi Importazione",
        "errorMessage": "Impossibile caricare le prenotazioni. Riprovare più tardi.",
        "step1": {
          "downloadTemplate": "Scarica Il Modello",
          "message1": "Prima di caricare il file, tieni presente quanto segue:",
          "message2": {
            "part1": "Il tuo file .csv deve contenere i campi ",
            "part2": "ID prenotazione, numero di adulti, numero di bambini, tipo di camera, data di prenotazione, data di arrivo, data di partenza, status e importo totale."
          },
          "message3": "I valori dei campi che contengono date, importi o stati devono essere nello stesso formato indicato nel nostro modello.",
          "message4": "Dopo aver caricato il file, assegna tutti i campi richiesti."
        },
        "step2": {
          "import": "Importare",
          "invalidData": "Valore non valido \"{value}\" trovato nel campo \"{field}\". Se il tuo file contiene intestazioni, controlla la checkbox \"L'intestazione è inclusa nel file\".",
          "message": "Assegnate tutti i campi necessari. Controllate quindi i dati e importateli nel database.",
          "notMapped": "Non mappato",
          "settings": {
            "message": "L'intestazione è contenuta nel file",
            "title": "Settings"
          }
        },
        "successMessage": "Prenotazioni caricate con successo.",
        "title": "Prenotazioni di importazione"
      },
      "show": "Mostra",
      "status": "Status",
      "stay": "Soggiorno"
    },
    "userManagement": {
      "aboutUser": "INFORMAZIONI SULL'UTENTE",
      "addNewUser": " Aggiungi un nuovo utente",
      "addUser": "Aggiungere un utente",
      "adminPermissions": "PERMESSI ADMIN",
      "admins": "ADMINS",
      "areYouSureThatYouWantToRemoveCompany": "Sei sicuro di voler rimuovere <fiirstname> <lastname> dall'hotel <companyName> (companyId)?",
      "assignCompany": "ASSEGNARE HOTEL",
      "assignedCompanies": "HOTEL ASSEGNATE",
      "assignNewCompany": "ASSEGNARE UNA NUOVO HOTEL",
      "backToUsers": "Torniamo agli utenti",
      "beCareful": "Attenzione",
      "cancelled": "Cancellato",
      "changeStatus": "Cambia stato",
      "changeStatusConfirmation": "Sei sicuro di voler {action} {fullname}",
      "companies": "Hotels",
      "company": "Hotel",
      "companyCount": "Numero di aziende",
      "customers": "CLIENTI",
      "definite": "Definitivo",
      "delete": "CANCELLARE",
      "disable": "disabilitare",
      "disabled": "Disattivato",
      "disableWarningMessage": "se si disabilita questo account, l'utente non potrà più accedere a RateBoard. È possibile ripristinare questa azione in un secondo momento.",
      "email": "E-mail",
      "enable": "abilitare",
      "enabled": "Attivato",
      "error": {
        "duplicateEmail": "L'utente con e-mail esiste già",
        "existingInvitation": "L'utente è già stato invitato.",
        "existingInvitationToCompany": "L'utente è già stato invitato in questo hotel.",
        "fillAll": "Si prega di compilare tutti i campi."
      },
      "expired": "Scaduto",
      "firstname": "Nome",
      "id": "ID",
      "language": "Linguaggio",
      "lastname": "Cognome",
      "loading": "Tanti...",
      "makeAdminWarning": "l'abilitazione dei permessi di amministratore consente all'utente di accedere a tutti gli account e di apportarvi modifiche. Assicurarsi di aver selezionato l'utente corretto prima di procedere.",
      "manageAdmins": "AMMINISTRARE GLI AMMINISTRATORI",
      "manageAdminsModal": "Amministrare gli amministratori",
      "mfaRequired": "2FA",
      "none": "-",
      "openInvite": "INVITO APERTO",
      "openInvites": "Inviti generali",
      "prospect": "Prospettiva",
      "rateboardUser": "Utente Rateboard",
      "rateboardUsers": "Amministrare gli amministratori",
      "remove": "RIMUOVERE",
      "removeCompany": "Rimuovi hotel",
      "resendInvite": "RINVIARE INVITO",
      "role": "RUOLO",
      "searchFor": "Cercare per",
      "searchPlaceholder": "Cercare...",
      "seeAll": "Mostra tutti",
      "selectCompany": "Selezionare l'hotel",
      "selectUser": "Selezionare un utente che si desidera rendere ADMIN",
      "sendInvite": "Invia invito",
      "status": "STATUS",
      "statusHeader": "Stato",
      "user": "Utente",
      "userId": "ID utente",
      "username": "Nome utente",
      "users": "Utenti"
    }
  },
  "alert": {
    "message": {
      "error": "Qualcosa è andato storto!",
      "success": "La Sua richiesta è stata processata."
    },
    "title": {
      "error": "Errore!",
      "success": "Successo!"
    }
  },
  "analyse": {
    "comparison": {
      "chartTitles": {
        "occupancy": "Sviluppo dell'occupazione",
        "revenue": "Sviluppo del revenue"
      },
      "filters": {
        "label": {
          "main": "Intervallo di date principale",
          "reference": "Intervallo di date di riferimento"
        }
      },
      "occupancyChart": {
        "tooltip": {
          "daysBeforeEnd": "Giorni alla scadenza",
          "dba": "DBA",
          "occupancy": "@:analyse.filters.kpi.occupancy"
        }
      },
      "revenueChart": {
        "tooltip": {
          "adr": "@:analyse.filters.kpi.adr",
          "daysBeforeEnd": "Giorni alla scadenza",
          "dba": "DBA",
          "revenue": "@:analyse.filters.kpi.revenue",
          "revPar": "@:analyse.filters.kpi.revpar"
        }
      },
      "slider": {
        "adr": "@:analyse.filters.kpi.adr",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "revPar": "@:analyse.filters.kpi.revpar"
      },
      "table": {
        "adr": "@:analyse.filters.kpi.adr",
        "adrReference": "@:analyse.filters.kpi.adr Rif.",
        "daysBeforeEndDate": "Giorni prima della scadenza",
        "dba": "DBA",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "occupancyReference": "@:analyse.filters.kpi.occupancy Rif.",
        "revenue": "@:analyse.filters.kpi.revenue",
        "revenueReference": "@:analyse.filters.kpi.revenue Rif.",
        "revpar": "@:analyse.filters.kpi.revpar",
        "revparReference": "@:analyse.filters.kpi.revpar Rif."
      },
      "title": "Confronto Intervallo di Date",
      "tooltips": {
        "charts": {
          "occupancy": "Sviluppo dell'occupazione nel tempo fino all'ultimo giorno specificato del periodo.",
          "revenue": "Sviluppo del revenue nel tempo fino all'ultimo giorno specificato del periodo."
        },
        "infoTiles": {
          "adr": "ADR (Average Daily Rate) medio attuale per il periodo principale selezionato. Inoltre, è possibile visualizzare lo scostamento rispetto al periodo di riferimento selezionato.",
          "forecast": "Previsione del numero totale di camere vendute e del tasso di occupazione nel periodo principale (se questo è futuro). La previsione viene generata per i prossimi 12 mesi ed è disponibile se i dati sono sufficienti.",
          "occupancy": "Occupazione attuale per l'intervallo di date principale selezionato (numero totale di camere e occupazione media in %). Inoltre, è possibile vedere la differenza con l'intervallo di date di riferimento selezionato.",
          "revenue": "Revenue totale attuale per l'intervallo di date principale selezionato. Inoltre, è possibile visualizzare la differenza rispetto all'intervallo di date di riferimento selezionato.",
          "revPar": "RevPar (Revenue Per Available Room) attuale medio per il periodo principale selezionato. Inoltre, puoi vedere la differenza rispetto al periodo di riferimento selezionato.",
          "vacantRooms": "Numero totale di camere ancora disponibili per il periodo principale selezionato. Inoltre, è visibile la differenza con l'intervallo di date di riferimento selezionato."
        }
      }
    },
    "filters": {
      "distribution": {
        "channels": "Canali",
        "countries": "Paesi",
        "room_category": "Categorie camere",
        "room_type": "Tipo di camera",
        "segment_categories": "Categorie di segmento",
        "segments": "Segmenti"
      },
      "filter": {
        "channels": "CANALI",
        "complimentary": "Complementare",
        "countries": "PAESI",
        "group": "Gruppo",
        "not_set": "Nessuno",
        "pickup": "PICKUP",
        "pickup_14days": "14 Giorni",
        "pickup_1day": "1 Giorno",
        "pickup_30days": "30 Giorni",
        "pickup_3days": "3 Giorni",
        "pickup_60days": "60 Giorni",
        "pickup_7days": "7 Giorni",
        "pickup_90days": "90 Giorni",
        "room_categories": "CATEGORIE CAMERE",
        "room_types": "TIPO DI CAMERA",
        "segment_categories": "CATEGORIE DI SEGMENTO",
        "segments": "SEGMENTI"
      },
      "kpi": {
        "adr": "ADR",
        "occupancy": "Occupazione",
        "revenue": "Revenue",
        "revpar": "RevPAR"
      },
      "labels": {
        "distribution": "Distribuzione",
        "filter": "Filtro",
        "kpi": "Valore",
        "reference1": "1° Referenza",
        "reference2": "2° Referenza"
      },
      "reference": {
        "budget": "BUDGET",
        "final_2_years_ago": "FINALE 2 ANNI PRECEDENTE",
        "final_2_years_ago_same_date": "Stessa Data finale 2Y",
        "final_2_years_ago_same_day_week": "Stesso gg. sett. finale 2Y",
        "final_last_year": "FINALE DELL'ANNO SCORSO",
        "final_last_year_same_date": "Stessa Data finale 1Y",
        "final_last_year_same_day_week": "Stesso gg. sett. finale 1Y",
        "same_date": "Stessa data",
        "same_day_week": "Stesso giorno della settimana",
        "same_time_2_years_ago": "STESSO TEMPO 2 ANNI PRECEDENTE",
        "same_time_2_years_ago_same_date": "Stessa Data YTD 2Y",
        "same_time_2_years_ago_same_day_week": "Stesso gg. sett. YTD 2Y",
        "same_time_last_year": "STESSO TEMPO ANNO PRECEDENTE",
        "same_time_last_year_same_date": "Stessa Data YTD 1Y",
        "same_time_last_year_same_day_week": "Stesso gg. sett. YTD 1Y",
        "show_budget": "Mostra budget"
      }
    },
    "hotel": {
      "analyseChart": {
        "legend": {
          "bar": {
            "pickup": {
              "cancellations": "Disdetto",
              "confirmations": "Confermati",
              "otb": "OTB"
            },
            "reference1": "(1ª Referenza)",
            "reference2": "(2ª Referenza)"
          },
          "budget": "Budget",
          "event": {
            "primary": "Evento",
            "reference1": "Evento (1ª Referenza)",
            "reference2": "Evento (2ª Referenza)"
          },
          "forecast": "{kpi} Forecast",
          "forecastTooltip": "Previsione per i prossimi 12 mesi vengono visualizzate solo se, in base a criteri generali, la base dati è sufficiente. L'ombreggiatura della linea indica il probabile intervallo di variazione nel Forecast.",
          "line": {
            "primary": "Ultima tariffa inviata",
            "reference1": "Ultima tariffa inviata (1ª Referenza)",
            "reference2": "Ultima tariffa inviata (2ª Referenza)"
          }
        },
        "noData": "Nessun dato disponibile"
      },
      "detail": {
        "header": "@:analyse.hotel.detail.headerNoReference rispetto al <b>{referenceDate}</b>",
        "headerNoReference": "Dettagli per il <b>{date}</b>",
        "headerWithSecond": "@:analyse.hotel.detail.header i <b>{secondReferenceDate}</b>",
        "placeholder": "Clicca su una data nel grafico per mostrare i dettagli",
        "tooltip": {
          "developmentChart": "Sviluppo dei KPI nel tempo in base al DBA (giorni prima dell'arrivo).",
          "rateUpdatesChart": "Tariffe attive (cioè quelle che sono state davvero inviate) nel tempo per categoria camera."
        }
      },
      "developmentChart": {
        "availableRooms": "Camere disponibili",
        "availableRooms1": "Camere disponibili (@:analyse.hotel.gridItems.reference1)",
        "availableRooms2": "Camere disponibili (@:analyse.hotel.gridItems.reference2)",
        "forecast": "Forecast",
        "roomsSold": "Camere vendute",
        "roomsSold1": "Camere vendute (@:analyse.hotel.gridItems.reference1)",
        "roomsSold2": "Camere vendute (@:analyse.hotel.gridItems.reference2)",
        "title": "Sviluppo",
        "tooltip": {
          "adr": "@:analyse.filters.kpi.adr",
          "availableRooms": "Camere disponibili",
          "dba": "Giorni primadell'arrivo",
          "occupancy": "@:analyse.filters.kpi.occupancy",
          "revenue": "@:analyse.filters.kpi.revenue",
          "revPar": "@:analyse.filters.kpi.revpar",
          "roomsSold": "Camere vendute"
        },
        "vacantRooms": "Camere Vuote"
      },
      "gridItems": {
        "adr": "@:analyse.filters.kpi.adr",
        "availableRooms": "Camere disponibili",
        "forecast": "Forecast",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "reference1": "1ª Referenza",
        "reference2": "2ª Referenza",
        "revenue": "@:analyse.filters.kpi.revenue",
        "revPar": "@:analyse.filters.kpi.revpar",
        "roomNights": "Pernottamenti"
      },
      "indicator": "Dettagli sopra",
      "infoTiles": {
        "adr": "ADR (Average Daily Rate) attuale per la data selezionata. Ulteriormente, puoi vedere la differenza con il valore all'anno scorso.",
        "tooltip": {
          "forecast": "La previsione per il giorno selezionato è disponibile, se i dati sono sufficienti, per gli indicatori reddito e occupazione (camere vendute previste). Viene generata per i prossimi 12 mesi.",
          "forecastNoData": "Forecast non calcolata per il passato",
          "revenue": "Revenue attuale per la data selezionata. Ulteriormente, puoi vedere la differenza con il valore all'anno scorso.",
          "revpar": "RevPAR (Revenue Per Available Room) attuale per la data che hai scelto. Inoltre, puoi vedere la differenza rispetto al riferimento che hai scelto.",
          "roomsSold": "Occupazione attuale per la data selezionata. Ulteriormente, puoi vedere la differenza con il finale all'anno scorso.",
          "vacantRooms": "Numero di camere ancora disponibili per la data selezionata. Ulteriormente, puoi vedere la differenza con il valore all'anno scorso."
        }
      },
      "rateUpdatesChart": {
        "title": "Aggiornamenti sulle tariffe"
      },
      "showSentRate": "Mostra l'ultima tariffa inviata",
      "title": "Dati dell'hotel",
      "tooltip": {
        "budget": "Budget",
        "forecast": "Forecast",
        "lastRateSent": "Ultima tariffa inviata",
        "total": "Totale"
      }
    },
    "table": {
      "activeRate": "Tariffa attiva",
      "date": "Data",
      "firstDifference": "Prima differenza",
      "firstReference": "@:analyse.filters.labels.reference1",
      "secondDifference": "Seconda differenza",
      "secondReference": "@:analyse.filters.labels.reference2",
      "summary": "Sommario",
      "total": "Totale"
    }
  },
  "assistant": {
    "actions": {
      "cancel": "Annulla",
      "close": "Chiudi",
      "collapse": "Comprimi",
      "delete": "Elimina",
      "download": "Esporta",
      "edit": "Modifica",
      "expand": "Espandi",
      "newChat": "Nuova chat",
      "rename": "Rinomina",
      "submit": "Invia",
      "update": "Aggiorna"
    },
    "chat": {
      "actions": {
        "send": "Invia",
        "sending": "Invio in corso..."
      },
      "disclaimer": {
        "linkText": "Questa è l'IA.",
        "text": "L'IA può commettere errori e non conosce tutte le circostanze. Verifica quindi le informazioni fornite e affidati sempre al tuo giudizio."
      },
      "emptyState": {
        "descriptions": {
          "first": "L'IA Revenue Manager analizza i tuoi dati, il mercato, le previsioni e molto altro per aiutarti a prendere decisioni più consapevoli. Consideralo come un partner con cui confrontarti, in grado di offrirti analisi e suggerimenti utili per il revenue management.",
          "fourth": "Mantieni sempre il controllo: l'IA Revenue Manager non apporta autonomamente modifiche in RateBoard.",
          "second": "Sei tu a conoscere meglio la tua struttura. L'IA Revenue Manager lavora sulla base dei dati disponibili e potrebbe non conoscere tutti gli aspetti rilevanti della tua struttura. La decisione finale spetta sempre a te.",
          "third": "Puoi chiedere in qualsiasi momento tabelle o grafici per visualizzare e comprendere meglio i dati."
        }
      },
      "message": {
        "chart": {
          "legend": {
            "clickToHide": "Clicca per nascondere",
            "clickToShow": "Clicca per mostrare"
          }
        },
        "download": {
          "chart": {
            "png": "Scarica PNG"
          },
          "table": {
            "csv": "Scarica CSV"
          }
        },
        "error": {
          "actions": {
            "retryPrevious": "Reinvia la domanda precedente"
          },
          "descriptions": {
            "tooManyPendingMessages": "L'IA Revenue Manager sta ancora gestendo le tue altre conversazioni aperte. Attendi qualche istante e poi reinvia il messaggio.",
            "unknownError": "L'IA Revenue Manager non può rispondere al momento a causa di un problema tecnico. Attendi un momento e riprova. Se il problema persiste, contatta il nostro team di supporto."
          },
          "titles": {
            "tooManyPendingMessages": "Troppe domande in corso di elaborazione",
            "unknownError": "Problema tecnico"
          }
        },
        "errorNote": {
          "error": "La richiesta non è stata elaborata a causa di un errore.",
          "usageLimit": "È stato raggiunto il limite giornaliero."
        },
        "exportMessage": "Esporta messaggio",
        "feedback": {
          "placeholderDown": "Spiega cosa non ti è stato utile",
          "placeholderUp": "Cosa hai trovato utile? (opzionale)",
          "thumbsDown": "Pollice in giù",
          "thumbsUp": "Pollice in su",
          "title": "Il tuo feedback"
        },
        "loadingMessages": "Caricamento messaggi...",
        "pending": {
          "pending": "Messaggio ricevuto: l'IA Revenue Manager se ne occuperà a breve",
          "phase": {
            "callingAgent": "Pensando...",
            "createMessage": "Inizializzazione in corso...",
            "processTool": "Analisi dei dati in corso...",
            "scheduleMessage": "Richiesta in coda...",
            "synthesizingResponse": "In fase di completamento..."
          },
          "thinking": "L'IA Revenue Manager sta elaborando la tua richiesta. Analisi dei dati in corso...",
          "thinkingTakesLonger": "L'analisi è ancora in corso: più dati sono presenti, più tempo occorre per fornire una risposta dettagliata. Puoi uscire da questa chat in qualsiasi momento; la risposta sarà qui ad aspettarti al tuo ritorno.",
          "tool": {
            "citeKnowledgeSource": "Annotazione delle fonti di conoscenza...",
            "getAnalyseStats": "Verifica delle statistiche di performance OTB...",
            "getCapacity": "Verifica della capacità alberghiera complessiva...",
            "getCategoryNames": "Ricerca dei nomi delle categorie...",
            "getClosedDays": "Verifica dei giorni di chiusura...",
            "getCurrentDateTime": "Verifica dell'ora locale dell'hotel...",
            "getCurrentWeather": "Verifica del meteo attuale...",
            "getEvents": "Ricerca degli eventi...",
            "getFilterValues": "Recupero delle opzioni di filtro disponibili...",
            "getForecasterCompany": "Verifica della configurazione di previsione...",
            "getFullMessageContent": "Lettura della cronologia completa dei messaggi...",
            "getFutureWeather": "Verifica delle previsioni meteo...",
            "getLastSentRates": "Ricerca delle tariffe attive...",
            "getMarketOccupancyComparisonStats": "Confronto delle performance di occupazione del mercato...",
            "getMarketPickupComparisonStats": "Confronto dei trend di pickup e cancellazione del mercato...",
            "getOccupancyForecast": "Verifica delle forecast di occupazione...",
            "getPickupDevelopmentStats": "Analisi dei trend di pickup e cancellazione...",
            "getPickupStats": "Verifica delle statistiche di pickup e cancellazione...",
            "getRatesToConfirm": "Raccolta tariffe in attesa di conferma...",
            "getRecommendedRates": "Verifica delle tariffe consigliate...",
            "getRegionForecast": "Verifica dei dettagli della forecast regionale...",
            "getRevenueForecast": "Verifica delle forecast di revenue...",
            "getRoomTypeNames": "Ricerca dei nomi delle tipologie di camera...",
            "getShiftedDateOnSameDay": "Calcolo della data corrispondente...",
            "getShiftedDateOnSameWeekday": "Ricerca del giorno della settimana corrispondente...",
            "getShiftedDatePeriod": "Regolazione dell'intervallo di date...",
            "loadFullSkill": "Revisione dei passaggi per questa attività...",
            "resolveObservationDate": "Individuazione della data esatta di osservazione..."
          }
        },
        "printSender": {
          "assistant": "IA Revenue Manager",
          "system": "Sistema"
        },
        "toggle": {
          "chart": "grafico",
          "hide": "Nascondi {label}",
          "show": "Mostra {label}",
          "sources": "articoli correlati della Knowledge Base",
          "table": "tabella"
        }
      },
      "notEnoughCredits": {
        "inactiveTier": "Stai utilizzando RateBoard {tier}, ovvero RateBoard senza l'AI Revenue Manager. Se desideri utilizzarlo, {sendUsARequest}: troveremo insieme la soluzione più adatta alla tua struttura.",
        "inactiveTierTitle": "Il tuo piano non include crediti IA",
        "moreCredits": "Il <b>{date}</b> avrai di nuovo credito a disposizione e potrai riprendere esattamente da dove avevi interrotto.",
        "moreCreditsDaily": "Domani avrai di nuovo credito a disposizione e potrai riprendere esattamente da dove avevi interrotto.",
        "needMoreAiCredits": "Hai bisogno di più credito per l'IA?",
        "requestItNow": "Richiedilo ora.",
        "sendUsARequest": "inviaci una richiesta",
        "title": "Hai raggiunto il limite di utilizzo del tuo piano.",
        "youveUsedAllYourCredits": "Hai raggiunto il tuo limite giornaliero attuale"
      },
      "prompt": {
        "placeholder": "Scrivi qui il tuo messaggio..."
      },
      "responseFormat": {
        "label": "Visualizza come"
      },
      "suggestions": {
        "mobileMenuLabel": "Domande suggerite"
      }
    },
    "conversation": {
      "dateLabels": {
        "today": "Oggi"
      },
      "editPlaceholder": "Inserisci un nuovo titolo per la chat",
      "loadingMore": "Caricamento in corso...",
      "loadMore": "Mostra altri"
    },
    "conversations": "Conversazioni",
    "creditUsage": {
      "adminOnlyInfo": "Modalità RateBoard · Utilizzo gratuito",
      "availableCredits": "Credito disponibile",
      "dripBoost": {
        "daily": "Ricarica giornaliera",
        "weekly": "Ricarica settimanale"
      },
      "noCreditsInThisTier": "Nessun credito IA in {tier}",
      "ofMonthlyCreditsUsed": "del credito mensile utilizzato",
      "requestAiManager": "Richiedi l'IA Revenue Manager",
      "requestItNow": "Richiedilo ora.",
      "requestMoreCredits": "Hai bisogno di più credito per l'IA?",
      "requestUsage": "Hai bisogno di più credito per l'IA?",
      "tiers": {
        "custom": "Custom",
        "disabled": "Performance",
        "smart": "Smart"
      },
      "tooltip": {
        "availableCreditsDescription": "Credito disponibile da subito.",
        "description": "Il credito disponibile dipende dal tuo piano.",
        "dripDescription": {
          "daily": "Credito incluso che si sblocca automaticamente ogni giorno.",
          "weekly": "Credito incluso, che si sblocca automaticamente ogni settimana."
        },
        "title": "Spiegazione dei limiti di utilizzo",
        "usedCreditsDescription": "Credito utilizzato questo mese."
      },
      "usage": "Utilizzo",
      "usedCredits": "Credito utilizzato"
    },
    "icon": {
      "label": "IA"
    },
    "modal": {
      "delete": {
        "message": "Vuoi cancellare la conversazione {title}? Questa azione non può essere annullata.",
        "title": "Cancella conversazione"
      },
      "edit": {
        "title": "Modifica il titolo della conversazione"
      }
    },
    "untitled": "Senza titolo"
  },
  "back": "Indietro",
  "benchmarking": {
    "cancellationChart": {
      "title": "Cancellazione"
    },
    "chartHeader": {
      "inMonth": "a {month}",
      "legacyMonthPrefix": "in",
      "lessThanMarket": "{value}% meno del mercato",
      "moreThanMarket": "{value}% più del mercato",
      "thisMonth": "questo mese",
      "tooltip": {
        "adr": {
          "description": "Questo grafico mostra la tariffa giornaliera media per mese, per i 6 mesi passati e futuri, e la confronta con la media del mercato. Fare clic su un mese per visualizzare i dati giornalieri."
        },
        "cancellation": {
          "description": "Questo grafico mostra le cancellazioni per mese, per gli ultimi 12 mesi, e le confronta con la media del mercato. Fare clic su un mese per visualizzare i dati giornalieri.",
          "title": "Cancellazione"
        },
        "occupancy": {
          "description": "Questo grafico mostra l’occupazione totale per mese, per i 6 mesi passati e futuri, e la confronta con la media del mercato. Fare clic su un mese per visualizzare i dati giornalieri.",
          "title": "Occupazione"
        },
        "pickup": {
          "description": "Questo grafico mostra il pickup netto (pickup - cancellazioni) per mese, per gli ultimi 12 mesi, e lo confronta con la media del mercato. Fare clic su un mese per visualizzare i dati giornalieri.",
          "title": "Pernottamenti"
        },
        "pickupAndCancellation": {
          "description": "Questo grafico mostra il pickup totale e le cancellazioni degli ultimi 30 giorni e li confronta con la media del mercato.",
          "title": "Pickup e cancellazione"
        },
        "revpar": {
          "description": "Questo grafico mostra il RevPAR medio per mese, per i 6 mesi passati e futuri, e lo confronta con la media del mercato. Fare clic su un mese per visualizzare i dati giornalieri."
        },
        "stayDays": {
          "description": "Questo grafico mostra la distribuzione del pickup e delle cancellazioni degli ultimi 30 giorni e li confronta con la media del mercato.",
          "title": "Giorni di soggiorno"
        }
      }
    },
    "chartLabels": {
      "currentMonth": "Mese corrente",
      "market": "Mercato",
      "yourCompany": "Il tuo Hotel"
    },
    "description": {
      "message1": "Definisci il tuo gruppo di confronto utilizzando i filtri ",
      "message2": "Regione, Categoria di stelle, Focus dell'hotel",
      "message3": " (es. Benessere, Famiglie, …) e ",
      "message4": "Tipologia di hotel",
      "message5": " (Business e/o Leisure).",
      "message6": "Non limitarti a considerare solo l'area geografica immediata; includi anche tipologie di hotel simili in altre regioni comparabili",
      "message7": " – in questo modo otterrai benchmark più significativi ed equi per il tuo hotel. Il pool di dati dovrebbe essere il più ampio possibile, garantendo al contempo la massima omogeneità.",
      "title1": "INFORMAZIONE IMPORTANTE!",
      "title2": "Come scegliere il tuo mercato:"
    },
    "dualTooltip": {
      "company": "Il tuo hotel",
      "market": "Mercato"
    },
    "infoTile": {
      "averageRateIndex": {
        "indicatorValue": "@:benchmarking.infoTile.rateGenerationIndex.indicatorValue",
        "title": "Indice della tariffa media",
        "tooltip": {
          "description": "Questa scheda mostra la deviazione dell’ADR dell’hotel rispetto alla media del mercato. ARI = ADR dell’hotel / ADR medio del mercato.",
          "title": "Indice della tariffa media"
        },
        "underline": "@:benchmarking.infoTile.rateGenerationIndex.underline"
      },
      "lastMinutePickup": {
        "indicatorValue": {
          "decrease": "@:benchmarking.infoTile.pickup.indicatorValue.decrease",
          "increase": "@:benchmarking.infoTile.pickup.indicatorValue.increase"
        },
        "title": "Last minute Pickup",
        "underline": "pernottamenti nelle ultime 2 settimane per le prossime 2 settimane"
      },
      "marketPenetrationIndex": {
        "indicatorValue": "@:benchmarking.infoTile.rateGenerationIndex.indicatorValue",
        "title": "Indice di penetrazione del mercato",
        "tooltip": {
          "description": "Questa scheda mostra la deviazione dell’occupazione dell’hotel rispetto alla media del mercato. MPI = Tasso di occupazione dell’hotel / Tasso di occupazione medio del mercato * 100.",
          "title": "Indice di penetrazione del mercato"
        },
        "underline": "@:benchmarking.infoTile.rateGenerationIndex.underline"
      },
      "pickup": {
        "indicatorValue": {
          "decrease": "{n}% meno del mercato",
          "increase": "{n}% più del mercato"
        },
        "title": "Pickup",
        "underline": "Ultime 2 settimane"
      },
      "rateGenerationIndex": {
        "indicatorValue": "{s} questo anno solare",
        "title": "Indice di generazione tariffaria",
        "tooltip": {
          "description": "Questa scheda mostra la deviazione del RevPAR dell’hotel rispetto alla media del mercato. RGI = RevPAR dell’hotel / RevPAR medio del mercato.",
          "title": "Indice di generazione tariffaria"
        },
        "underline": "questo mese del calendario"
      },
      "roomNights": "Pernottamenti",
      "trendingMonth": {
        "indicatorValue": "{d} per il mercato",
        "title": "Mese di tendenza",
        "underline": "{n} pernottamenti nelle ultime 2 settimane"
      }
    },
    "last30Days": "Ultimi 30 giorni",
    "marketFilter": {
      "applyFilters": "Applicare i filtri",
      "comparedTo": {
        "comparedTo": "Rispetto a",
        "country": "Paese dell'hotel",
        "district": "Distretto dell'hotel",
        "group": {
          "country": "PAESE",
          "district": "DISTRETTO",
          "state": "REGIONE",
          "zipCode": "CAP"
        },
        "state": "Regione dell'hotel",
        "zipCode": "CAP dell'hotel"
      },
      "hotelsFocus": "Focus dell'hotel",
      "hotelsType": "Tipo di hotel",
      "stars": "Stelle",
      "tooLittleData": "Dati di mercato insufficienti. Prova ad ampliare i filtri di selezione."
    },
    "newUi": {
      "advancedMode": "Modalità avanzata",
      "advancedModeExplanation": "Utilizza i filtri qui sotto per definire il tuo gruppo di confronto. Il bacino dati dovrebbe essere il più ampio possibile, mantenendo al contempo la massima omogeneità. Includi ad esempio anche hotel simili in altre regioni comparabili.",
      "country": "Paese",
      "district": "Distretto",
      "headerTooltip": "La pagina di benchmarking mette a confronto i KPI chiave con il mercato più rilevante per te. Nella nostra {knowledgeBase} trovi esempi pratici, consigli e supporto nell'analisi dei risultati.",
      "help": "Aiuto benchmarking",
      "market": "Mercato",
      "marketLoadError": "Non è stato possibile caricare le impostazioni del mercato.",
      "marketNotAvailableTooltip": "L'analisi del mercato della competizione per il tuo hotel è già stata effettuata e il quadro è stato definito in modo ottimale.",
      "marketSaveError": "Non è stato possibile salvare le impostazioni del mercato.",
      "marketSaveSuccess": "Impostazioni del mercato salvate correttamente.",
      "marketSettings": "Configura il mercato",
      "marketTooltip": "Non è stato ancora definito alcun mercato. Contatta il nostro team di assistenza.",
      "newPreset": "Nuovo",
      "noFilters": "Nessun mercato",
      "presets": "Preset",
      "readOnlyMarketExplanation": "Questo mercato è gestito da RateBoard ed è di sola lettura per il tuo hotel.",
      "region": "Regione turistica\ndell'Alto Adige",
      "retry": "Riprova",
      "saveChanges": "Salva modifiche",
      "state": "Regione",
      "title": "Benchmarking",
      "tourismRegion": {
        "AHRNTAL": "Valle Aurina",
        "ALTA_BADIA": "Regione Dolomiti Alta Badia",
        "BOZEN": "Bolzano e dintorni",
        "BRIXEN": "Bressanone e dintorni",
        "DREI_ZINNEN": "Regione Dolomiti Tre Cime",
        "EGGENTAL": "Regione Dolomiti Eggental",
        "GROEDEN": "Regione Dolomiti Val Gardena",
        "KRONPLATZ": "Regione Dolomiti Plan de Corones",
        "MERAN": "Merano e dintorni",
        "NONE": "nessuna",
        "SEISER_ALM": "Regione Dolomiti Alpe di Siusi",
        "STERZING": "Vipiteno e dintorni",
        "VILLNOESSTAL": "Regione Dolomiti Val di Funes",
        "VINSCHGAU": "Val Venosta",
        "WEINSTRASSE": "Strada del Vino dell'Alto Adige"
      },
      "zipCode": "CAP"
    },
    "occupancyChart": {
      "title": "Occupazione"
    },
    "pickupAndCancellationsChart": {
      "labels": {
        "cancellation": "Le tue cancellazioni",
        "cancellationMarket": "Cancellazioni del mercato",
        "pickup": "Il tuo PickUp",
        "pickupMarket": "PickUp del mercato"
      },
      "title": "PickUp e cancellazione"
    },
    "pickupChart": {
      "title": "Pickup"
    },
    "stayDays": {
      "title": "Giorni di soggiorno per PickUp e cancellazione"
    },
    "upselling": {
      "activated": {
        "customize": "Personalizza la tua vista con filtri come paese, tipo di hotel o categoria stelle e confrontati con i concorrenti più rilevanti per te.",
        "stayTuned": "Resta sintonizzato — la funzione sarà rilasciata il <b>01.07.2025</b> e potrai accedere a preziose informazioni sul tuo mercato. Monitora indicatori chiave come Occupazione, ADR, PickUp e altro per vedere come ti posizioni.",
        "title": "Complimenti! La funzione di benchmarking è attivata"
      },
      "notActivated": {
        "alreadyRequested": " La funzionalità è già stata ordinata. Firma il contratto digitale che ti abbiamo inviato via email. Il benchmarking verrà attivato.",
        "box": {
          "activate": "attivare e testare",
          "analyze": "Analizzare indicatori come occupazione,pickup e ADR",
          "comparison": "Confrontarsi con hotel simili",
          "customFilter": "Filtri personalizzati: regione, tipologia di hotel, categoria e target",
          "info": "Contratto via e-mail, attivazione dopo la firma.",
          "moreInformation": "MAGGIORI INFORMAZIONI",
          "questions": "In caso di domande, contattateci telefonicamente o per e-mail all'indirizzo <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a>.",
          "resendContract": "Non riuscite a trovare l'e-mail? Cliccate semplicemente sul pulsante e riceverete nuovamente il contratto:",
          "resendContractButton": "REINVIARE IL CONTRATTO",
          "revenuePotential": "Riconoscere il potenziale di fatturato",
          "signContract": "Per completare l'attivazione, firmate il contratto che avete ricevuto per e-mail. La funzione di benchmarking sarà disponibile solo dopo la firma del contratto.",
          "transparency": "Il modulo di benchmarking utilizza dati anonimizzati e aggregati di molte strutture – non è possibile risalire a singoli hotel, nemmeno in riferimento alla loro dimensione o adaltre informazioni specifiche. È possibile annullare la partecipazione in qualsiasi momento scrivendo a <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a>; in tal caso, il modulo non sarà più disponibile.",
          "withdrawal": "Solo {fee} - prova con 7 giorni di diritto di recesso.",
          "withdrawalFee": "{fee}€/mese"
        },
        "compareFigures": "Confronta indicatori chiave come occupazione, tariffa media, pickup e molti altri per periodi futuri e passati. Crea confronti personalizzati basati su filtri liberamente selezionabili come paese, tipologia di hotel, categoria stelle, focus specifico dell'hotel e molto altro confrontati con chi vuoi <b>tu.</b>",
        "identifyOpportunities": "Identifica opportunità di mercato per {company} e genera ricavi, concentrandoti sui periodi di alta domanda.",
        "underline": "DECISIONI BASATE SUI DATI"
      },
      "timer": {
        "days": "Giorno | Giorni",
        "untilRelease": "al release"
      }
    }
  },
  "cancel": "Annulla",
  "clean": "Svuotare",
  "close": "Vicino",
  "companyValues": {
    "focus": {
      "AIRPORT": "Aeroporto",
      "BUSINESS_TRIPS": "Viaggi d'affari",
      "CITY_TRIPS": "Viaggi in città",
      "CONFERENCES": "Conferenze",
      "CUISINE": "Cucina",
      "FAMILY": "Famiglia e bambini",
      "MOUNTAIN": "Sport di montagna",
      "NATURE": "Natura",
      "WATER": "Attività acquatiche",
      "WELLNESS": "Benessere"
    },
    "segment": {
      "BUSINESS": "Affari",
      "LEISURE": "Svago",
      "LEISURE_BUSINESS": "Svago e Affari"
    },
    "stars": {
      "FIVE": "5 Stelle",
      "FIVE_SUPERIOR": "5 Stelle Superiori",
      "FOUR": "4 Stelle",
      "FOUR_SUPERIOR": "4 Stelle Superiori",
      "NOT_RATED": "Non valutato",
      "ONE": "1 Stella",
      "THREE": "3 Stelle",
      "THREE_SUPERIOR": "3 Stelle Superiori",
      "TWO": "2 Stelle"
    }
  },
  "compare": "Confronta",
  "connect": {
    "error": {
      "button": "Vai a RateBoard",
      "message": "Non siamo riusciti a collegare Apaleo a RateBoard, contatta il tuo responsabile Onboarding per maggiori informazioni.",
      "title": "Qualcosa non é andato buon fine!"
    },
    "pending": {
      "button": "Connetti proprietà",
      "message": "Prima di continuare, seleziona la proprietà desiderata di collegare.",
      "title": "Ci siamo quasi!"
    },
    "selectProperty": "Selezionare la proprietà",
    "success": {
      "button": "Vai a RateBoard",
      "message": "La tua proprietà è stata connessa con successo. Per ulteriori informazioni, contatta il vostro responsabile Onboarding.",
      "title": "Sei connesso!"
    }
  },
  "dashboard": {
    "chart": {
      "noData": "Nessun dato disponibile",
      "week": "sett."
    },
    "createModal": {
      "cancel": "Annulla",
      "create": "Crea dashboard",
      "errors": {
        "duplicate": "Esiste già una dashboard con questo nome.",
        "empty": "Inserire un nome.",
        "length": "Massimo 40 caratteri."
      },
      "fieldText": "Assegna un nome univoco alla dashboard",
      "placeholder": "es. Panoramica settimanale",
      "title": "Nuova dashboard"
    },
    "emptyState": "Non hai ancora aggiunto alcun widget a questa schermata. Clicca su “Aggiungi widget” e aggiungi indicatori chiave come RevPAR, tasso di occupazione o ricavi da ritiro per monitorare le tue prestazioni a colpo d’occhio.",
    "header": {
      "addWidget": "AGGIUNGI WIDGET",
      "downloadPdf": "Scarica PDF",
      "pmsDataFreshness": {
        "label": "Dati PMS aggiornati: {timestamp}",
        "tooltip": {
          "contactSupport": "Contatta il supporto",
          "message": "Problemi nella trasmissione dei dati."
        }
      },
      "widgetLimitReached": "Hai raggiunto il limite massimo di {limit} widget. Elimina un widget esistente per crearne uno nuovo."
    },
    "switcher": {
      "copySuffix": "copia",
      "createNew": "Crea nuovo...",
      "dashboardLimitReached": "Hai raggiunto il limite massimo di {limit} dashboard. Elimina una dashboard esistente per crearne una nuova.",
      "deleteDashboardModal": {
        "message": "Questa azione non può essere annullata. La modifica interessa solo il tuo account.",
        "title": "Sei sicuro di voler eliminare la dashboard “{name}”?"
      },
      "duplicateDashboard": "Duplica dashboard",
      "duplicateModal": {
        "label": "Nome dashboard"
      },
      "lastDashboardCannotBeDeleted": "Questa dashboard non può essere eliminata perché deve esistere almeno una dashboard.",
      "nameValidation": "Inserisci un nome dashboard univoco.",
      "newDashboardName": "Dashboard senza titolo",
      "noDashboardSelected": "Nessuna dashboard selezionata"
    },
    "templateManagement": {
      "archive": "Archivia",
      "archived": "Archiviato",
      "archiveMessage": "Il modello non sarà più disponibile per gli utenti e i dashboard già creati da questo modello non subiranno modifiche. Potrai comunque accedervi e pubblicarlo di nuovo in seguito.",
      "archiveTitle": "Vuoi davvero archiviare il modello {name}?",
      "chooseFile": "Scegli file",
      "copySuffix": "copia",
      "create": "Crea modello",
      "createAction": "Crea modello",
      "deleteMessage": "Non potrai annullare questa azione in un secondo momento. Il modello verrà eliminato per tutti i SUPER-ADMIN.",
      "deleteTitle": "Vuoi davvero eliminare il modello {name}?",
      "draft": "Bozza",
      "duplicate": "Duplica modello",
      "duplicateAction": "Duplica modello",
      "edit": "Modifica",
      "error": "Non è stato possibile salvare il modello. Riprova.",
      "fields": "Campi del modello",
      "isOnboardingTemplate": "Modello di onboarding",
      "loading": "Caricamento dei modelli...",
      "manage": "Gestisci modelli",
      "nameDe": "Nome tedesco",
      "nameEn": "Nome inglese",
      "nameIt": "Nome italiano",
      "newTemplate": "Nuovo modello",
      "noThumbnail": "Nessun file selezionato",
      "onboardingDefault": "Predefinito per onboarding",
      "placeholderNames": {
        "de": "Neue Vorlage",
        "en": "New Template",
        "it": "Nuovo modello"
      },
      "publish": "Pubblica",
      "publishAction": "Pubblica modello",
      "published": "Pubblicato",
      "publishMessage": "Il modello sarà visibile a tutti gli utenti.",
      "publishTitle": "Vuoi davvero pubblicare il modello {name}?",
      "settings": "Impostazioni",
      "thumbnail": "Miniatura",
      "thumbnailAvailable": "Miniatura disponibile",
      "thumbnailError": "Non è stato possibile caricare la miniatura. Riprova.",
      "thumbnailRequired": "Per pubblicare un modello è necessaria una miniatura.",
      "title": "Gestisci modelli",
      "unpublish": "Annulla pubblicazione",
      "validation": "Inserisci nomi univoci in tedesco, inglese e italiano.",
      "view": "Visualizza",
      "viewThumbnail": "Visualizza miniatura"
    },
    "templatesModal": {
      "createNew": "Dashboard personalizzata",
      "subtitle": "Seleziona un'opzione per creare una nuova dashboard.",
      "title": "Modelli"
    },
    "widgetLibrary": {
      "add": "Aggiungi",
      "header": {
        "cancel": "Annulla",
        "selectWidgets": "Seleziona i widget da aggiungere nella dashboard"
      },
      "preview": {
        "notifications": {
          "bookings20Lower": "Prenotazioni inferiori del 20%",
          "revenue15Higher": "Ricavi superiori del 15%"
        },
        "weather": {
          "city": "Innsbruck"
        }
      },
      "search": {
        "placeholder": "Cerca widget..."
      },
      "title": "Libreria widget",
      "widgetTypes": {
        "adr": "ADR",
        "all": "Tutti i widget",
        "budgetGoal": "Obiettivo di budget",
        "cancellation": {
          "revenue": "Revenue cancellata",
          "roomNights": "Pernottamenti cancellati",
          "title": "Cancellazioni"
        },
        "market": "Mercato",
        "notification": "Notifiche",
        "occupancy": "Occupazione",
        "pickup": {
          "distribution": "Distribuzione Pickup",
          "revenue": "pickup revenue lordo",
          "revenueTotal": "PICKUP REVENUE NETTO",
          "roomNights": "Pickup Lordo",
          "roomNightsTotal": "Pickup Netto",
          "title": "Pickup"
        },
        "rateAdjustment": "Raccomandazioni tariffarie",
        "revenue": "Revenue",
        "review": "Recensione",
        "revPar": "RevPAR",
        "today": "Oggi",
        "weather": "Meteo"
      }
    },
    "widgets": {
      "adr": {
        "title": "ADR",
        "tooltipKpi": "ADR"
      },
      "budgetGoal": {
        "differenceToGoal": "Differenza rispetto all'obiettivo",
        "goalOccupancy": "Occupancy Obiettivo",
        "goalRevenue": "Revenue Obiettivo",
        "otbOccupancy": "Occupancy OTB",
        "otbRevenue": "Revenue OTB",
        "title": "Obiettivo di budget",
        "tooltipKpi": "OTB"
      },
      "cancellationRevenue": {
        "legendKpi": "Revenue cancellata",
        "title": "Revenue cancellata",
        "tooltipKpi": "Revenue cancellata"
      },
      "cancellationRoomNights": {
        "cancellations": "Cancellazioni",
        "title": "Pernottamenti cancellati",
        "tooltipKpi": "Pernottamenti cancellati"
      },
      "market": {
        "companyAverage": "Il mio hotel",
        "differenceToMarket": "Scostamento dal mercato",
        "infoTooltip": "I valori di mercato sono dati PMS reali degli hotel del tuo mercato di benchmarking geografico. Il forecast regionale mostra l'andamento della domanda nella tua regione.",
        "infoTooltipHeader": "NOVITÀ! La tua occupazione a confronto con il mercato.",
        "marketAverage": "Mercato",
        "occupancy": "Occupazione",
        "occupancyThisMonth": "Occupazione di questo mese",
        "regionalForecast": "Forecast regionale",
        "title": "Mercato"
      },
      "notification": {
        "activated": "Attivato {date}",
        "affectedDays": "{count} giorni interessati dal {from} al {to}",
        "noData": "Non hai notifiche attive, vai alla pagina Notifiche per gestirle.",
        "title": "Notifiche"
      },
      "occupancy": {
        "forecastTooltip": "Forecast",
        "title": "Occupazione",
        "tooltipKpi": "Occupazione"
      },
      "pickupDistribution": {
        "cancelledRoomnights": "Pernottamenti cancellati",
        "confirmedRoomnights": "Pernottamenti confermati",
        "timeRange": {
          "custom": "dal {from} al {to}",
          "lastDays": "degli ultimi {count} giorni",
          "lastMonths": "degli ultimi {count} mesi",
          "today": "di oggi",
          "yesterday": "di ieri"
        },
        "title": "Distribuzione Pickup"
      },
      "pickupRevenue": {
        "title": "pickup revenue lordo",
        "tooltipKpi": "Pickup Revenue Lordo"
      },
      "pickupRevenueTotal": {
        "cancelledLabel": "Cancellazioni revenue",
        "netLegendLabel": "Netto {year}",
        "netValueLabel": "Pickup revenue",
        "pickupLabel": "Pickup revenue lordo",
        "title": "PICKUP REVENUE NETTO",
        "tooltipKpi": "Revenue"
      },
      "pickupRoomNights": {
        "title": "Pickup Lordo",
        "tooltipKpi": "Pickup Lordo"
      },
      "pickupRoomNightsTotal": {
        "cancelledLabel": "Cancellazioni",
        "netLabel": "Pickup lordo",
        "netLegendLabel": "Netto {year}",
        "netValueLabel": "Pernottamenti netti",
        "pickupLabel": "Pickup lordo",
        "title": "Pickup Netto",
        "tooltipKpi": "Pernottamenti"
      },
      "rateAdjustment": {
        "majorRateAdjustments": "Raccomandazioni rilevanti",
        "noData": "Non ci sono raccomandazioni tariffarie per i prossimi 12 mesi. Controlla le impostazioni per assicurarti che sia tutto configurato correttamente.",
        "rateAdjustments": "Raccomandazioni tariffarie",
        "subtitle": "Per i prossimi 12 mesi",
        "title": "Raccomandazioni tariffarie"
      },
      "rateAdjustmentsCount": {
        "subtitle": "completati negli ultimi 7 giorni",
        "title": "Adeguamenti tariffari"
      },
      "reference": "Riferimento",
      "revenue": {
        "forecastTooltip": "Forecast",
        "title": "Revenue",
        "tooltipKpi": "Revenue "
      },
      "reviews": {
        "average": "Media",
        "overallDistribution": "Distribuzione complessiva",
        "reviewsCount": "{count} recensioni negli ultimi 6 mesi",
        "title": "Recensioni"
      },
      "revPar": {
        "title": "RevPAR",
        "tooltipKpi": "RevPAR"
      },
      "settings": {
        "cancel": "Annulla",
        "category": {
          "label": "Filtra per"
        },
        "comparison": {
          "groups": {
            "final2YearsAgo": "FINALE 2 ANNI PRECEDENTE",
            "finalLastYear": "FINALE DELL’ANNO SCORSO",
            "sameTime2YearsAgo": "STESSO TEMPO 2 ANNI PRECEDENTE",
            "sameTimeLastYear": "STESSO TEMPO ANNO PRECEDENTE"
          },
          "label": "Confronta con",
          "options": {
            "custom": "Personalizzato",
            "lastYear": "L'anno scorso",
            "none": "Non selezionato",
            "sameDate2YearsAgo": "Stessa Data YTD 2Y",
            "sameDate2YearsAgoFinal": "Stessa Data finale 2Y",
            "sameDateLastYear": "Stessa Data YTD 1Y",
            "sameDateLastYearFinal": "Stessa Data finale 1Y",
            "sameWeekday2YearsAgo": "Stesso gg. sett. YTD 2Y",
            "sameWeekday2YearsAgoFinal": "Stesso gg. sett. finale 2Y",
            "sameWeekdayLastYear": "Stesso gg. sett. YTD 1Y",
            "sameWeekdayLastYearFinal": "Stesso gg. sett. finale 1Y"
          }
        },
        "done": "Salva",
        "kpi": {
          "label": "KPI",
          "options": {
            "occupancy": "Occupazione",
            "revenue": "Revenue"
          }
        },
        "majorDiff": {
          "label": "Rilevanza",
          "tooltip": "Sul grafico verranno visualizzati i tassi consigliati che sono superiori o inferiori del x % rispetto all'ultima tariffa.",
          "tooltipTitle": "Rilevanza"
        },
        "rateType": {
          "label": "Tipo di tariffa",
          "options": {
            "highest": "Più alto",
            "lowest": "Il più basso"
          }
        },
        "remove": "Rimuovi",
        "size": {
          "label": "Dimensioni",
          "options": {
            "large": "Grande",
            "medium": "Medio",
            "small": "Piccolo"
          }
        },
        "timeRange": {
          "label": "Intervallo di tempo",
          "options": {
            "currentMonth": "Mese corrente",
            "currentQuarter": "Trimestre corrente",
            "currentWeek": "Settimana corrente",
            "currentYear": "Anno corrente",
            "custom": "Personalizzato",
            "last12Months": "Ultimi 12 mesi",
            "last14Days": "Ultimi 14 giorni",
            "last30Days": "Ultimi 30 giorni",
            "last3Days": "Ultimi 3 giorni",
            "last6Months": "Ultimi 6 mesi",
            "last7Days": "Ultimi 7 giorni",
            "last90Days": "Ultimi 90 giorni",
            "next12Months": "Prossimi 12 mesi",
            "next14Days": "Prossimi 14 giorni",
            "next30Days": "Prossimi 30 giorni",
            "next6Months": "Prossimi 6 mesi",
            "next7Days": "Prossimi 7 giorni",
            "next90Days": "Prossimi 90 giorni",
            "today": "Oggi",
            "yesterday": "Ieri"
          },
          "optionsSince": {
            "last12Months": "Da 12 mesi",
            "last14Days": "Da 14 giorni",
            "last30Days": "Da 30 giorni",
            "last6Months": "Da 6 mesi",
            "last7Days": "Da 7 giorni",
            "last90Days": "Da 90 giorni"
          }
        },
        "title": "Impostazioni del widget",
        "validation": {
          "dateRangeRequired": "Intervallo di date obbligatorio"
        }
      },
      "timeRangeLabels": {
        "comparisonSubtitles": {
          "lastYear": "all'anno scorso",
          "sameDate2YearsAgo": "2 anni fa",
          "sameDateLastYear": "all'anno scorso",
          "sameWeekday2YearsAgo": "2 anni fa",
          "sameWeekdayLastYear": "all'anno scorso",
          "twoYearsAgo": "a 2 anni fa"
        },
        "differenceTo": "Rispetto",
        "inThe": "Negli",
        "subtitles": {
          "currentMonth": "Nel mese corrente",
          "currentQuarter": "Nel trimestre corrente",
          "currentWeek": "Nella settimana di calendario corrente",
          "currentYear": "Nell'anno corrente",
          "last12Months": "ultimi 12 mesi",
          "last14Days": "ultimi 14 giorni",
          "last30Days": "ultimi 30 giorni",
          "last6Months": "ultimi 6 mesi",
          "last7Days": "ultimi 7 giorni",
          "last90Days": "ultimi 90 giorni",
          "next12Months": "prossimi 12 mesi",
          "next14Days": "prossimi 14 giorni",
          "next30Days": "prossimi 30 giorni",
          "next6Months": "prossimi 6 mesi",
          "next7Days": "prossimi 7 giorni",
          "next90Days": "prossimi 90 giorni"
        },
        "tooltipSubtitles": {
          "sameDate2YearsAgo": "stessa data (stesso tempo 2 anni precedente YTD 2Y)",
          "sameDate2YearsAgoFinal": "stessa data (finale)",
          "sameDateLastYear": "stessa data (stesso tempo anno precedente YTD 1Y)",
          "sameDateLastYearFinal": "stessa data (finale)",
          "sameWeekday2YearsAgo": "stesso gg. sett. (stesso tempo 2 anni precedente YTD 2Y)",
          "sameWeekday2YearsAgoFinal": "stesso gg. sett. (finale)",
          "sameWeekdayLastYear": "stesso gg. sett. (stesso tempo anno precedente YTD 1Y)",
          "sameWeekdayLastYearFinal": "stesso gg. sett. (finale)"
        }
      },
      "today": {
        "adr": "ADR",
        "cancellation": "Cancellazioni",
        "cancellationRevenue": "Revenue cancellazioni",
        "netPickup": "Net Pickup",
        "netPickupRevenue": "Revenue net pickup",
        "occupancy": "Occupazione",
        "revenue": "Revenue",
        "revpar": "RevPAR",
        "subtitleToday": "Oggi",
        "title": "Oggi"
      },
      "weather": {
        "highLow": "Max: {high}° Min: {low}°",
        "noData": "Nessun dato meteo disponibile",
        "title": "Meteo",
        "wind": "Vento: {speed}km/h"
      }
    }
  },
  "dataPrivacyAgreement": {
    "beforeAccessSign": "Prima di poter accedere alla pagina dell'hotel, è necessario firmare l'Accordo sul trattamento dei dati (DPA) per garantire il rispetto delle norme sulla privacy.",
    "canStillAccess": "È comunque possibile accedere agli altri hotel a cui si è stati assegnati.",
    "notAccessUntilSigned": "Purtroppo non è possibile accedere a questo hotel fino a quando l'accordo sulla protezione dei dati (DPA) non viene firmato da uno degli utenti ADMIN dell'hotel.",
    "readAndSign": "LEGGERE E FIRMARE IL DPA"
  },
  "dataTable": {
    "empty": "Non ci sono elementi da visualizzare.",
    "loading": "Caricamento...",
    "of": "da",
    "page": "Pagina",
    "to": "a"
  },
  "deactivated": "Disattivato",
  "delete": "Rimuovere",
  "dropdownSelect": {
    "all": "Tutti",
    "empty": "Vuoto",
    "none": "Nessuno",
    "noneChosen": "Non selezionato",
    "nSelected": "{number} selezionati"
  },
  "error": "Errore",
  "fileUploader": {
    "choose": "Seleziona file",
    "dragAndDrop": "Trascina qui il file o clicca per selezionarlo",
    "invalidFile": "Il file è vuoto o in un formato non corretto. Carica un file valido.",
    "remove": "Rimuovi file"
  },
  "filterPreset": {
    "modal": {
      "message": "Immettere un nome univoco per salvare la preimpostazione per un utilizzo futuro",
      "title": "Salva nuovo filtro come predefinito"
    },
    "newPreset": "Nuovo predefinito",
    "preset": "Preimpostazione",
    "presets": "Predefinito"
  },
  "footer": {
    "contact": {
      "title": "Contattaci"
    },
    "support": {
      "times1": "Lunedì - Giovedì, 8:00 - 17:00 CET",
      "times2": "Venerdì, 08:00 - 14:00 CET",
      "title": "Tempi di supporto"
    }
  },
  "header": {
    "knowledgeBase": "Knowledge Base",
    "menu": {
      "administration": {
        "assistant": "Assistente",
        "connectivityStats": "Connectivity stats",
        "customerSuccessManagement": "CSM",
        "forecastControl": "Forecast Control",
        "hotelAdministration": "Amministrazione",
        "inboundData": "Dati in ingresso",
        "monitoring": "Monitoring",
        "outboundLogs": "Outbound Logs",
        "rateEnginePOC": "RateEngine POC",
        "regionForecastControl": "Region Forecast Control",
        "reportsOverview": "Tabella Rapporti",
        "reservationOverview": "Tabella prenotazioni",
        "schedulers": "Scheduler",
        "users": "Users"
      },
      "analyse": {
        "analyse": "Analisi",
        "budget": "Budget",
        "comparison": "@:analyse.comparison.title",
        "competitors": "Concorrenti",
        "hotel": "@:analyse.hotel.title",
        "marketTrends": "Tendenze di mercato",
        "pickUp": "PickUp",
        "reputation": "Recensioni"
      },
      "settings": {
        "budgetConfiguration": "Configurazione Budget",
        "competitors": "Concorrenti",
        "events": "Eventi",
        "interfaceConfiguration": "Configurazione Interfacce",
        "inventory": "Gestione Inventario",
        "notifications": "Notifiche",
        "priceLevels": "Livelli di prezzi",
        "ratePlans": "Rate Plans",
        "rateRounding": "Arrotondare la tariffa",
        "rateRules": "Rate Rules",
        "restrictions": "Restrizioni",
        "roomPricingConfiguration": "Configurazione prezzi",
        "segmentation": "Segmentazione",
        "statusConfiguration": "Impostazioni status"
      },
      "title": {
        "activityLog": "Registro attività",
        "administration": "Amministrazione",
        "analyse": "Analisi",
        "dashboard": "Dashboard",
        "manage": "Gestione",
        "settings": "Impostazioni"
      }
    },
    "releaseNotes": "Release Notes"
  },
  "hotelSelection": {
    "message": "Selezionare una proprietà predefinita che verrà visualizzata quando si accede a RateBoard. È possibile modificarla in seguito nella pagina delle impostazioni del profilo.",
    "title": "Selezionare la proprietà predefinito"
  },
  "inventory": {
    "capacity": {
      "addButton": {
        "text": "Aggiungi..."
      },
      "changeDateDialog": {
        "title": "Cambiare data"
      },
      "datePicker": {
        "changeDate": "Cambiare data",
        "label": "Data:"
      },
      "deleteImpossibleTooltipText": "Impossible cancellare impostazione. Deve esistere impostazioni per almeno 3 anni nel passato.",
      "details": "Details",
      "error": {
        "threeYearsRequired": "Almeno tre anni devono essere inseriti.",
        "totalAtLeastOne": "Il numero di camere totale deve essere almeno 1."
      },
      "manualSettingNotPossible": {
        "text": "Stiamo importando le informazioni sulla capacità direttamente da PMS. La configurazione manuale della capacità è dunque disabilitata.",
        "title": "Impossibile impostare l'inventario manualmente."
      },
      "options": "Options",
      "roomsAndCount": "Rooms and count",
      "totalAvailable": {
        "label": "Totale:"
      }
    },
    "configuration": {
      "errorMessage": "Attenzione! Non tutti i campi contengono valori.",
      "options": "Opzioni",
      "pmsTitle": "Lista dei tipi dal PMS",
      "priceWarning": "La modifica di \"Tipo primario\" o \"Categoria\" può causare l'errata impostazione dei livelli di prezzo per alcune camere. Si prega di verificare le impostazioni del livello in seguito al cambio!!!",
      "showExcludedRooms": "Mostra tipi esclusi",
      "table": {
        "category": "Categoria",
        "options": {
          "active": "Actif",
          "archived": "Archiviato",
          "excluded": "Escluso",
          "header": "Opzioni"
        },
        "primary": "Primario",
        "roomType": "Tipo camera"
      },
      "unresolvableWarning": "Impossibile ricalcolare le impostazioni tariffari per i giorni seguenti: {dates}. Sovrascritture vengono cancellate. Sei sicuro di continuare?"
    },
    "tabs": {
      "capacity": "Capacità",
      "configuration": "Configurazione"
    },
    "title": "Gestione Inventario"
  },
  "invitationConfirmation": {
    "allDone": "Completato!",
    "confirmInvitation": "Conferma le tue informazioni per procedere e creare il tuo account RateBoard.",
    "createPassword": "Crea password",
    "createPasswordSoLogin": "Crea una password per accedere al tuo account RateBoard.",
    "fields": {
      "acceptTerms": "Accetta Termini di utilizzo e Informativa sulla privacy",
      "confirmPassword": "Conferma password",
      "password": "Password"
    },
    "goToLogin": "VAI ALLA PAGINA DI LOGIN",
    "hotelAssigned": "L'hotel {company} è stato assegnato con successo al tuo conto RateBoard. Potete già effettuare il login e accedere all'hotel.",
    "invitationNotFound": {
      "message": "Contatta la persona che ha inviato l'invito o il nostro team se il problema persiste.",
      "title": "Siamo spiacenti, nessun invito trovato."
    },
    "inviteAlreadyAccepted": "L'invito era già stato accettato.",
    "invitedToJoin": "Sei stato invitato a iscriverti all'Hotel {company}",
    "inviteExpired": "Siamo spiacenti, questo invito è scaduto",
    "somethingWrongHappened": "Siamo spiacenti, è successo un errore",
    "submitLabel": "CREA UTENTE",
    "unableToCreate": "Sembra che non siamo riusciti a creare il tuo account. Può riprovare utilizzando lo stesso link.",
    "unfortunatelyInviteExpired": "Si prega di contattare il nostro team di supporto a <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a> per richiedere un nuovo link.",
    "validation": {
      "confirmPassword": "Le password non corrispondono",
      "email": "L'e-mail non corrisponde all'invito",
      "password": "La password deve contenere almeno 8 caratteri"
    }
  },
  "login": {
    "account": "Non hai un account?",
    "contactus": "Contattaci",
    "error": {
      "blocked": "Troppi tentativi di accesso errati. Account bloccato per 10 minuti!",
      "blockedNew": "Per motivi di sicurezza, il tuo account viene bloccato per 10 minuti a causa di molteplici tentativi di accesso errati.",
      "browser": "Browser non supportato!",
      "credentials": "Accesso non riuscito",
      "credentialsNew": "Siamo spiacenti, non è stato possibile accedere. \nControlla se hai il nome utente e la password corretti.",
      "noActiveCompany": "Nessun hotel attivo è assegnato a questo utente."
    },
    "forgotPassword": {
      "email": "Controlla la tua email per ulteriori istruzioni!",
      "emailNew": "Controlla la tua casella di posta: ti abbiamo inviato un collegamento per reimpostare la password.",
      "forgot": "Password dimenticata",
      "reset": {
        "button": "Resetta",
        "buttonNew": "Invia e-mail",
        "description": "Invieremo un collegamento per la reimpostazione della password al tuo indirizzo email.",
        "link": "Resetta la password"
      }
    },
    "password": "password",
    "twoFactorAuthentication": {
      "authenticationDevice": "Non riuscite a utilizzare il vostro dispositivo per l'autenticazione?",
      "otpInputField": "Codice a 6 cifre",
      "title": "Autenticazione a due fattori"
    },
    "username": "nome utente",
    "usernameOrEmail": "Nome utente o indirizzo e-mail"
  },
  "logout": "Logout",
  "maintenanceMode": {
    "message": "<b>Attualmente stiamo eseguendo lavori di manutenzione su RateBoard —</b> sarà di nuovo online a breve. Stiamo apportando alcune migliorie per offrirti un’esperienza ancora migliore. Grazie per la tua pazienza!",
    "title": "Torniamo presto!"
  },
  "manage": {
    "autopilot": {
      "description": "Questa funziona invia automaticamente i suggerimenti di prezzo.",
      "dialog": {
        "applyAll": "Salva impostazioni per tutte le categorie di camera.",
        "difference": "diff.",
        "from": "dal",
        "fromTo1": "Pubblicare solamente tariffe per",
        "fromTo2": "giorni prima del giorno di arrivo.",
        "fromToEmpty": "Inizio e fine giorni di arrivo sono campi obbligatori.",
        "fromToNegative": "I giorni da e a prima dell'arrivo non possono essere negativi.",
        "fromToOverlap": "Inizio deve essere inferiore a Fine.",
        "fromToRange": "I giorni da e a prima dell'arrivo, devono essere compresi tra 0 e 540.",
        "lowerLimitLabel": "Imposta limite minimo",
        "rateOffset1": "Accetta",
        "rateOffset2": "SOPRA",
        "rateOffset3": "SOTTO",
        "rateOffsetActiveRate": "la tariffa attuale",
        "rateOffsetBaseRate": "il prezzo base",
        "rateOffsetConnector": "",
        "rateOffsetConnectorNegativeAll": "",
        "rateOffsetConnectorNegativeLimit": "che si discostano di meno del",
        "rateOffsetConnectorPositiveAll": "",
        "rateOffsetConnectorPositiveLimit": "che si discostano di più del",
        "rateOffsetEmpty": "La differenza non può essere vuota.",
        "rateOffsetEnd": "",
        "rateOffsetKnowledgebaseLinkLabel": "Knowledgebase",
        "rateOffsetKnowledgebaseText": "Qui trovi la documentazione dettagliata sulle impostazioni disponibili:",
        "rateOffsetLimitNote": "Se le tariffe suggerite superano o scendono al di sotto dei limiti impostati, l'Autopilot invierà la tariffa esattamente al valore limite definito.",
        "rateOffsetModeAllRates": "tutte le tariffe",
        "rateOffsetModeNoRates": "nessuna tariffa",
        "rateOffsetModeRatesUpTo": "solo tariffe",
        "rateOffsetNegative": "La differenza non può essere negativa.",
        "saveChanges": "Salva modifiche",
        "to": "al",
        "upperLimitLabel": "Imposta limite massimo"
      },
      "disabledTooltip": "Autopilot disabilitato",
      "enabledTooltip": "Autopilot attivo",
      "title": "Autopilot"
    },
    "calendar": {
      "day": {
        "autopilot": {
          "active": "Autopilot attivo",
          "fixedRate": "Autopilot disabilitato"
        },
        "closed": "Chiuso",
        "event": {
          "current": "Evento quest'anno",
          "past": "Evento anno precedente"
        },
        "modifications": {
          "algorithm": "Algoritmo",
          "baseRate": "Tariffa base",
          "primaryRecommendation": "Suggerimento primario",
          "rules": "Regole"
        },
        "rate": {
          "baseRateTooltip": "Prezzo di base più regole di prezzo (senza algoritmo)"
        },
        "rateSync": {
          "lastRate": "Ultimo aggiornamento tariffe"
        },
        "restriction": {
          "cta": "Chiuso per arrivi (CTA)",
          "ctd": "Chiuso per partenze (CTD)",
          "minLos": "Durata del soggiorno minima"
        }
      }
    },
    "changeLog": {
      "applyPublish": "Accettare e pubblicare",
      "discardChanges": "Cancella modifiche",
      "noChangesYet": "Non ci sono ancora cambiamenti registrati. Se modifichi le tariffe nel calendario, questi cambiamenti appariranno qui nel registro attivitá.",
      "responseCode": {
        "invalidRatePlanRoomCategories": "Alcune categorie di camera non hanno un valore nella struttura degli rate plan. Prego aggiustarlo sulla pagina Impostazioni/Rate Plans.",
        "invalidRoomMapping": "Alcune camere non corrispondono al tipo ID assegnato sul Channel Manager.",
        "invalidRoomPrices": "La configurazione dei prezzi non è valida.",
        "noApiUrl": "URL per interfaccia non impostata.",
        "noHotelCode": "Hotel code mancante!",
        "noPms": "Gestione del PMS mancante.",
        "noRate": "Non ci sono tariffe memorizzate per almeno un giorno selezionato. Non è possibile inviare senza tariffe.",
        "noRatePlan": "Settaggio del rateplan manca.",
        "normalGuestCountTooLarge": "Occupazione normale troppo alta. Prego aggiustare nella configurazione prezzi.",
        "noRoomsMapped": "Zimmertyp-Mapping für Schnittstelle fehlt.",
        "notMappedRooms": "Ci sono categorie di camera che non sono utilizzate da alcuna interfaccia (ad es. non mappate). Le tariffe e le restrizioni non saranno mai inviate per queste categorie. Si prega di accedere all'impostazione Inventario e archiviare queste categorie.",
        "publishDisabled": "L'invio di cambiamenti è disattivato per tutte le interfacce.",
        "ratesNotSaved": "Le tue tariffe non sono state salvate.",
        "restrictionsNotSaved": "Restrizioni non sono state salvate.",
        "roomTypePriceInvalid": "La configurazione dei prezzi non è valida per la tipologia di camera {roomTypeName}.",
        "unexpected": "Le tue dati non possono essere inviate, ma sono state salvate in RateBoard.",
        "unknownError": "Errore del server interno."
      },
      "responseMessage": {
        "noRateLevel": "Nessun livello di prezzo impostato.",
        "rateOutOfBounds": "La tariffa non rientra nella fascia di prezzo."
      },
      "reviewedHint": "Hai terminato tutti i cambiamenti e li hai controllati?",
      "table": {
        "category": "Categoria camera",
        "closed": "Chiuso",
        "cta": "CTA",
        "ctd": "CTD",
        "details": "Dettagli",
        "insteadOf": "invece di",
        "maxLos": "MaxLOS",
        "minLos": "MinLOS",
        "minLosOutOfRange": "Non tutti i tuoi PMS supportano MinLOS = {count}. Potresti non vedere lo stesso valore in tutti i tuoi PMS!",
        "open": "Aperto",
        "rooms": "Camere",
        "settingsRemoved": "Impostazioni vengono rimosse",
        "what": "Cosa",
        "when": "Quando"
      },
      "title": "Registro attivitá",
      "types": {
        "rate": "Modificato tariffa",
        "ratePlans": "Modificati rate plans",
        "rateSettings": "Modificato impostazioni per tariffe,",
        "restrictions": "Modificati restrizioni"
      },
      "warning": "Avviso",
      "warningMonthChange": "Se cambi il mese le modifiche non salvate vengono perse. Sei sicuro di continuare?",
      "warningRefreshPage": "Se procedi, le tue modifiche andranno perse! Vuoi continuare?"
    },
    "editRates": "Correggi le tariffe",
    "nextMonth": "Mese successivo",
    "noDaysSelected": "Al momento non è stato selezionata alcuna data. Seleziona una o più date dal calendario in modo da visualizzare i dettagli o aggiustare le tariffe.",
    "noRoomCategoryMapped": "Nessuna categoria di camera associata",
    "previousMonth": "Mese precedente",
    "recommendationStatus": {
      "completed": "Calcolo delle suggerimenti tariffe completato.",
      "finished": "Calcolo delle suggerimenti tariffe in corso. Questo potrebbe richiedere alcuni minuti.",
      "refreshRequired": "Aggiorna la pagina per aggiornare i suggerimenti prezzo",
      "title": "Stato dei Suggerimenti"
    },
    "resync": {
      "button": "Risincronizzare i dati",
      "disabledHint": "L'ultima risincronizzazione è ancora attiva. Per favore riprova più tardi.",
      "errorLog": {
        "downloadAll": "Tutti i download",
        "outOf": "{count1} a {count2} error(i)",
        "title": "Registro degli errori",
        "types": {
          "base": "Generali",
          "channel": "Channel",
          "rate": "Tariffa"
        }
      },
      "message": "Inviare le tariffe accettate e le restrizioni attive per i prossimi 24 mesi a tutti i PMS e CM collegati.",
      "modal": {
        "hint1": {
          "part1": "La risincronizzazione include le tariffe per i prossimi 24 mesi, nuovi restrizioni, nuove impostazioni nella configurazione prezzi, nuove impostazioni nei Piani tariffari e nuove impostazioni nei livelli di prezzo (derivazione delle tipologie di camere non primarie). La risincronizzazione ",
          "part2": "non accetta ",
          "part3": "nuove raccomandazioni tariffarie! ",
          "part4": "Importante! ",
          "part5": "Se le tariffe sono state modificate manualmente nel calendario della gestione, non verranno sovrascritte."
        },
        "hint2": {
          "part1": "Nota: ",
          "part2": "questo processo può richiedere un po' di tempo e non sarà possibile inviare nuove tariffe tramite il calendario della gestione finché non sarà completato. Preghiamo di assicurare di aver terminato tutte le modifiche nelle impostazioni prima di avviare la risincronizzazione. I messaggi di successo o eventuali messaggi di errore saranno visibili qui e nel registro delle attività dopo il completamento."
        },
        "message": "Siete sicuri di voler procedere? State per inviare le tariffe già accettate per tutte le tipologie di camere (incluso impostazioni nuove) a tutti i PMS e CM collegati.",
        "title": "Risincronizzazione"
      },
      "refresh": "Aggiornare",
      "resyncCompleted": "Risincronizzazione completata",
      "resyncFailed": "Risincronizzazione fallita",
      "resyncFailedHint": "La risincronizzazione non è riuscita, aprire il registro degli errori per verificarne i dettagli.",
      "resyncInProgress": "In corso",
      "resyncInProgressHint": "Questa operazione può richiedere un po' di tempo. Una volta terminato il processo, sarà possibile risincronizzare nuovamente o inviare nuove tariffe tramite il registro delle modifiche.",
      "title": "Risincronizzazione"
    },
    "roomCategory": "Categoria camera",
    "sidebar": {
      "autopilot": {
        "fixRates": "Disattiva autopilot",
        "forAllSelectedDays": "For all selected days",
        "hint1": {
          "message": "Disattivando l'autopilot per il periodo selezionato, fissate il prezzo attuale per la categoria scelta. L'autopilot rimane disattivo e potete gestire i prezzi soltanto manualmente."
        },
        "noAutopilotMessage": "L'autopilot non è attivo per almeno uno dei giorni selezionati.",
        "title": "Autopilot",
        "unfixRates": "Attiva Autopilot"
      },
      "cancel": {
        "title": "Annulla"
      },
      "overview": {
        "competitors": {
          "cancellable": "Cancellabile",
          "competitor": "Concorrenti",
          "empty": "Non ci sono tariffe relative ai tuoi concorrenti per questa data.",
          "mealType": {
            "allInclusive": "All inclusive",
            "breakfast": "Colazione",
            "fullBoard": "Pensione completa",
            "halfBoard": "Mezza pensione"
          },
          "title": "Concorrenti"
        },
        "events": {
          "empty": "Per la data selezionata non ci sono impostati eventi.",
          "title": "Eventi"
        },
        "forCategory": "Categoria",
        "forHotel": "Hotel",
        "hint1": {
          "message": "Maggiori dettagli su occupazione forecast pickup e concorrenti sono disponibili nell' ",
          "messageLink": "area support",
          "messageStop": ".",
          "title": "Spiegazione"
        },
        "notes": {
          "addNew": "Aggiungi nota",
          "edit": "Modifica nota",
          "from": "Da",
          "noteNotSaved": "Impossibile di salvare la nota. Riprovare",
          "placeholder": "La tua notizia",
          "title": "Note",
          "to": "a",
          "warningDeletion": "Questa azione non può essere annullata! Sei sicuro di voler cancellare questa nota?"
        },
        "statistics": {
          "adr": "ADR",
          "forecastErrorCodes": {
            "calculationError": "Non è stato possibile calcolare la previsione",
            "maximumDates": "Possono essere selezionati al massimo 3 giorni.",
            "onlyForHotel": "Previsione disponibile solo per l'intera azienda.",
            "someInvalid": "Nessuna previsione per alcuni dei giorni selezionati.",
            "unexpected": "Si è verificato un errore inatteso."
          },
          "forecastFinal": "Forecast/Final",
          "forSelectedDays": "Statistiche per i giorni selezionati",
          "groupBlocks": "Blocco di gruppo",
          "occupancy": "Occupazione",
          "occupancyBlocks": "Occupazione incl. blocchi",
          "pickup": "Pickup di oggi | Pickup di ieri | Pickup {count} giorni",
          "revenue": "Revenue",
          "revPar": "RevPAR",
          "vacantRooms": "Camere Vuote",
          "vacantRoomsBlocks": "Camere Vuote incl. blocchi"
        },
        "title": "Sommario"
      },
      "rateDescriptions": {
        "baseRate": "Tariffa base",
        "modifierTypes": {
          "derivation": "Derivazione",
          "matrix": "Algoritmo",
          "min": "Limite inferiore",
          "minMax": "Limite di tariffa",
          "minMaxMax": "Limite massimo",
          "minMaxMin": "Limite inferiore",
          "rateRounding": "Arrotondamento",
          "rateRule": "Regola: {modifierName}",
          "rateRules": "Regole"
        },
        "primaryRecommendation": "Suggerimento primario",
        "recommendedRate": "Tariffa suggerimenti",
        "title": "Calcolo"
      },
      "ratePlans": {
        "closed": "Chiuso",
        "closeOpen": "Close/open",
        "closeOpenDisabled": "Lo stato Close/open deve essere impostato direttamente nel PMS/CM.",
        "forAllCategories": "Salvare per tutte le categorie",
        "hint1": {
          "message": "I piani tariffari vengono aperti o chiusi tramite l'icona della porta. La derivazione dalla tariffa base può essere regolata con una percentuale o un importo fisso.",
          "title": "Fase 1"
        },
        "hint2": {
          "message": "Controlla le modifiche nel registro attività sotto il calendario.",
          "title": "Fase 2"
        },
        "hint3": {
          "message": "Se è tutto giusto, accetta e pubblica i tuoi cambiamenti.",
          "title": "Fase 3"
        },
        "noChange": "Nessuna modifica",
        "open": "Aperto",
        "perPerson": "A persona",
        "perUnit": "A unità",
        "title": "Rate Plans"
      },
      "rates": {
        "acceptAll": "Accetta tutti",
        "acceptAllText": "Accetta tutti suggerimenti",
        "adjust": "Aggiusta",
        "adjustment": "Aggiustamento",
        "allCategories": "Tutte le categorie",
        "autopilotMessage": "L'autopilot è attivo per almeno uno dei giorni selezionati. Per poter settare i prezzi manualmente dovete prima disattivare l'autopilot.",
        "baseRates": "Prezzi base",
        "default": "Default",
        "forCategory": "Categoria",
        "forHotel": "Hotel",
        "hint1": {
          "message": "Salva temporaneamente le tariffe aggiornate per visualizzarle nel calendario prezzi e nel registro attivitá.",
          "title": "Fase 1"
        },
        "hint2": {
          "message": "Verifica i cambiamenti nel registro attivitá che si trova sotto il calendario.",
          "title": "Fase 2"
        },
        "hint3": {
          "message": "Inviate le tariffe ai vostri channel attivi.",
          "title": "Fase 3"
        },
        "hint4": {
          "message": "La modificazione della tariffa primario cambia anche le tariffe delle camere derivate. Si può anche impostare le derivazioni per giorni individuali.",
          "title": "Modifica tariffe"
        },
        "hint5": {
          "message": "La modificazione della tariffa primario cambia anche le tariffe delle camere derivate.",
          "message2": "Le tariffe vengono aggiornate soltanto nei mesi in cui l'autopilota NON è attivo.",
          "title": "Modifica tariffe"
        },
        "notSet": "Non salvato",
        "rateStatus": {
          "baseInvalid": "La tariffa base non rientra nell'intervallo del livello di prezzo.",
          "basePriceLevelMissing": "Livello di prezzo mancante.",
          "checkChangeLog": "Modifiche salvate nel registro attività per la revisione.",
          "derivedInvalid1": "Le tariffa non sono nell'intervallo dei prezzi delle",
          "derivedInvalid2": "tipo di camera.",
          "derivedPriceLevelMissing1": "Livello di prezzo mancante di camera",
          "derivedPriceLevelMissing2": ".",
          "error": "Errore",
          "success": "Successo"
        },
        "restoreDefault": "Recupera default",
        "title": "Tariffe"
      },
      "restrictions": {
        "closed": "Chiuso",
        "cta": "Chiuso per arrivi (CTA)",
        "ctd": "Chiuso per partenze (CTD)",
        "current": "Attuale",
        "forAllCategories": "Salva impostazioni per tutte le categorie di camera",
        "hint1": {
          "message": "Applicare restrizioni temporaneamente nel calendario e protocollo.",
          "title": "Fase 1"
        },
        "hint2": {
          "message": "Verifica i cambiamenti nel registro attivitá che si trova sotto il calendario.",
          "title": "Fase 2"
        },
        "hint3": {
          "message": "Invia restrizioni ai sistemi connessi.",
          "title": "Fase 3"
        },
        "maxLos": "Massima durata del soggiorno (MaxLOS)",
        "minLos": "Minima durata del soggiorno (MinLOS)",
        "new": "Nuova",
        "notSet": "Non salvato",
        "notSupported": "Questa restrizione non è supportata dal vostro PMS/CM.",
        "notSupportedEnabled": "Restrizione non supportata o disattivata dal PMS/CM in uso.",
        "open": "Aperto",
        "outOfRange": "MinLOS non deve oltrepassare MaxLOS!",
        "setToZero": "Se si imposta MinLOS o MaxLOS a zero, questa restrizione verrà completamente rimossa.",
        "title": "Restrizioni",
        "upTo": "fino a"
      }
    },
    "smallScreen": {
      "message1": "Sembra che stia guardando il calendario su uno schermo piccolo.",
      "message2": "Per garantire una visibilità e modificabilità ottimali, il calendario viene visualizzato solo a risoluzioni più elevate.",
      "title": "Schermo piccolo"
    },
    "title": "Calendario prezzi",
    "today": "Today"
  },
  "marketTrends": {
    "chartHeader": {
      "amountOfSearches": "Quantità di ricerche",
      "userLocationMap": "Posizione dell'utente",
      "weeklySearchTrends": "Tendenze di ricerca settimanali",
      "yearlySearchTrends": "Tendenze di ricerca annuali"
    },
    "chartLabel": {
      "weeklySearchTrends": {
        "for": "Giorno cercato",
        "on": "Ricerca nei giorni"
      },
      "yearlySearchTrends": {
        "current": "Anno in corso",
        "forecast": "Previsioni",
        "past": "Anno passato"
      }
    },
    "from": "Da",
    "gridItem": {
      "ninety": {
        "title": "Ricerca totale",
        "underline": "Ultimi 90 giorni"
      },
      "thirty": {
        "title": "Ricerca totale",
        "underline": "Ultimi 30 giorni"
      },
      "trending": {
        "title": "Attualmente in tendenza",
        "trendingMonth13": "Pasqua",
        "trendingMonth14": "Capodanno"
      }
    },
    "newUi": {
      "amountOfSearchesTooltip": "Mostra il numero giornaliero di ricerche per l'area e l'intervallo di date selezionati.",
      "weeklySearch": "Ricerca settimanale",
      "yearlySearchTrend": "Tendenza di ricerca annuale"
    },
    "pageHeader": {
      "dateRange": "Query di ricerca da-a",
      "title": "Tendenze di mercato"
    },
    "regionOfInterest": {
      "country": "Paese",
      "label": "Ricerche in:",
      "region": "Provincia",
      "zip": "Codice postale"
    },
    "to": "a"
  },
  "modal": {
    "title": {
      "add": "Aggiungi"
    }
  },
  "netGrossSwitch": {
    "gross": "Lordi",
    "label": "Revenue:",
    "net": "Netti",
    "tooltip": "La selezione cambierà i dati dei ricavi in entrata da netti a lordi (e viceversa). I valori cambiano solo per le pagine che mostrano questo interruttore."
  },
  "next": "Continua",
  "no": "No",
  "notifications": {
    "banner": {
      "later": "Più tardi",
      "title": "Sono presenti nuovi avvisi di sistema"
    },
    "notifications": "Notifiche",
    "panel": {
      "empty": "Sembra che tutto sia pronto"
    },
    "payload": {
      "unmappedRoomTypesCount": "Il tipo di camera non è stato assegnato. Si prega di assegnarlo a una categoria nelle impostazioni dell'inventario. | Ci sono {count} tipi di stanze non assegnate. Si prega di assegnarli a una categoria nelle impostazioni dell'inventario.",
      "unmappedSegmentsCount": "Si ha un segmento non mappato | Sono presenti {count} segmenti non mappati"
    },
    "solveNow": "Risolvi ora",
    "systemAlerts": "Avvisi di sistema",
    "tag": {
      "roomType": {
        "unmappedRoomTypes": "Tipi di stanze non mappate"
      },
      "segment": {
        "unmappedSegments": "Segmenti non mappati"
      }
    }
  },
  "ok": "OK",
  "pageHeader": {
    "datesText": "Modifiche registrate da-a:"
  },
  "pageNotFound": {
    "customError": "Errore",
    "error": "Errore {status}",
    "errorMessage": {
      "401": "Oops! Non hai i permessi per visualizzare questa pagina. Assicurati di aver effettuato il login",
      "403": "Spiacente, non hai i permessi necessari per visualizzare questa pagina. Si prega di contattare il supporto per ulteriore assistenza",
      "404": "Oh no! La pagina che stai cercando non esiste",
      "500": "Spiacenti, qualcosa è andato storto da parte nostra. Si prega di riprovare più tardi",
      "503": "Spiacenti, al momento abbiamo delle difficoltà tecniche. Si prega di riprovare più tardi",
      "NoActiveHotel": "Nessun hotel attivo è assegnato a questo utente. Per favore contattare il responsabile support manager per ulteriori informazioni."
    },
    "goToDashboard": "Vai al Dashboard",
    "redirectMessage1": "Verrete reindirizzati alla Dashboard entro ",
    "redirectMessage2": "secondi."
  },
  "pickup": {
    "distribution": {
      "graph": {
        "otb": "OTB",
        "roomNightsCancelled": "Pernottamenti cancellate",
        "roomNightsConfirmed": "Pernottamenti confermate"
      },
      "header": "Distribuzione PickUp",
      "table": {
        "cancellations": "Cancellazioni",
        "cancellationsRevenue": "Cancellazioni Revenue",
        "currentLabel": "Selezione",
        "month": "Mese",
        "otb": "OTB",
        "otbRevenue": "Revenue OTB",
        "pickup": "Pickup",
        "pickupRevenue": "Pickup Revenue",
        "referenceLabel": "Referenza",
        "roomNights": "Pernottamenti",
        "totalRevenue": "Revenue Totale",
        "vacantRooms": "Camere Vuote"
      },
      "tooltips": {
        "graph": "Mostra la distribuzione dei pick-up per l'intervallo di date selezionato nei giorni/mesi futuri.",
        "graphHeader": "Diagramma “Distribuzione dei pick-up“",
        "table": "Mostra i risultati riassunti mese per mese.",
        "tableHeader": "Tabella “Distribuzione dei pick-up“"
      }
    },
    "filters": {
      "cancelledPickup": {
        "label": "PickUp annullato",
        "options": {
          "hide": "Nascondi",
          "show": "Mostra"
        }
      },
      "datePicker": {
        "label": "Intervallo",
        "ranges": {
          "last14Days": "Ultimi 14 giorni",
          "last7Days": "Ultimi 7 giorni",
          "lastMonth": "Ultimo mese",
          "thisMonth": "Questo mese",
          "thisWeek": "Questa settimana"
        },
        "tooltip": "Seleziona un intervallo di date fino a 1 anno."
      },
      "groupBy": {
        "label": "Raggruppare per",
        "options": {
          "none": "Nessuno",
          "roomCategory": "Categoria di camera",
          "segment": "Segmento"
        },
        "tooltip": "Il raggruppamento per segmentazione è disponibile solo se la categorizzazione della segmentazione è attiva nell'account. (puoi trovarli in Impostazioni > Segmentazione)"
      },
      "kpi": {
        "label": "Valore",
        "options": {
          "revenue": "Revenue",
          "roomNights": "Pernottamenti"
        }
      },
      "reference": {
        "label": "Referenza",
        "options": {
          "none": "Non selezionato",
          "previous2Years": "2 anni precedenti",
          "previousYear": "Anno precedente",
          "sameDate": "Stessa data",
          "sameDateOfWeek": "Stesso giorno della settimana"
        }
      }
    },
    "from": "Da",
    "pageHeader": "PickUp",
    "pickupPerDay": {
      "errorMessages": {
        "failedToFetchData": "Non siamo riusciti a caricare i dati necessari. Riprova più tardi.",
        "noData": "Nessun dato disponibile per i filtri selezionati. Prova con una combinazione diversa."
      },
      "graph": {
        "cancelled": "Annullati",
        "confirmed": "Confermati",
        "gained": "Confermati",
        "reference": "Referenza",
        "referenceCancelled": "Riferimento annullato",
        "referenceConfirmed": "Riferimento confermato",
        "referenceGained": "Riferimento acquisito",
        "referenceRevenue": "Revenue di riferimento",
        "referenceRoomNights": "Riferimenti pernottamenti camere",
        "revenue": "Revenue",
        "revenueCancelled": "Revenue annullati",
        "revenueGained": "Revenue confermati",
        "roomNights": "Pernottamenti",
        "roomNightsCancelled": "Pernottamenti cancellate",
        "roomNightsConfirmed": "Pernottamenti confermate",
        "segmentData": {
          "complimentary": "Complementare",
          "group": "Gruppo",
          "groupType": {
            "complimentary": "isComplimentary",
            "group": "isGroup",
            "none": "none"
          },
          "none": "Regolare"
        }
      },
      "header": "PickUp per giorno",
      "table": {
        "adr": "ADR",
        "cancellations": "Cancellazioni",
        "cancellationsRevenue": "Cancellazioni Revenue",
        "group": "Gruppo",
        "pickup": "Pickup",
        "pickupRevenue": "Pickup Revenue",
        "roomNights": "Pernottamenti",
        "totalRevenue": "Revenue Totale"
      },
      "tooltips": {
        "graph": "Visualizza il KPI selezionato distribuito sull'intervallo di date. Il KPI può ancora essere suddiviso per gruppi.",
        "graphHeader": "Grafico dei PickUp per giorno",
        "table": "Visualizza i risultati sommati per ciascun gruppo, se selezionato.",
        "tableHeader": "Tabella PickUp per giorno"
      }
    },
    "summary": {
      "header": "Riepilogo",
      "titles": {
        "adr": "ADR",
        "cancellations": "Cancellazioni",
        "pickupRoomNight": "PickUp",
        "revenue": "Revenue Totale"
      },
      "tooltips": {
        "adr": "Mostra la tariffa media giornaliera (ADR) per l'intervallo di date selezionato e la confronta con il riferimento selezionato.",
        "cancellations": "Mostra le cancellazioni effettuate durante il periodo selezionato. Se nel filtro è stato selezionato un riferimento, viene visualizzato un confronto.",
        "headerTooltip": "Visualizza la somma dei risultati per i filtri selezionati.",
        "pickupRoomNight": "Mostra il numero di pernottamenti nel periodo selezionato. Se è stato selezionato un riferimento nel filtro, viene visualizzato un confronto.",
        "revenue": "Mostra le vendite per l'intervallo di date selezionato e le confronta con il riferimento selezionato."
      }
    },
    "to": "a"
  },
  "report": "Report",
  "reputation": {
    "averageRate": {
      "title": "Punteggio medio",
      "tooltip": "Punteggio medio negli ultimi 6 mesi."
    },
    "business": {
      "title": "Affari",
      "tooltip": "Punteggio medio complessivo basato sugli ospiti che viaggiano per affari."
    },
    "couples": {
      "title": "Coppie",
      "tooltip": "Punteggio medio complessivo basato sugli ospiti in coppia."
    },
    "family": {
      "title": "Famiglia",
      "tooltip": "Punteggio medio complessivo basato sugli ospiti in famiglia."
    },
    "goodToKnow": "Buono a sapersi",
    "highlights": {
      "title": "In evidenza",
      "tooltip": "Gli argomenti più rilevanti del vostro hotel in base alle recensioni dei vostri ospiti."
    },
    "nationality": {
      "title": "Nazionalità",
      "tooltip": "Distribuzione delle recensioni in base alla nazionalità del viaggiatore."
    },
    "noReviews": "Nessuna recensione disponibile",
    "overallDistribution": {
      "title": "Distribuzione complessiva",
      "tooltip": "Come sono distribuiti i vostri ospiti in base alle categorie: punteggio, tipologia e lingua."
    },
    "overallScore": {
      "averageScore": "/5",
      "last6Months": "Ultimi 6 mesi",
      "reviews": "recensioni",
      "title": "Punteggio complessivo",
      "tooltip": "Punteggio medio del vostro hotel per tutto il tempo, in base alla categoria degli ospiti."
    },
    "pageHeader": "Reputation",
    "poweredBy": "gestito da",
    "rateDistribution": {
      "title": "Distribuzione punteggi",
      "tooltip": "Distribuzione delle recensioni in base al punteggio."
    },
    "relevantNow": {
      "title": "Rilevante ora",
      "tooltip": "Come è stato valutato il vostro hotel negli ultimi 6 mesi."
    },
    "reviewCount": {
      "reviews": "Recensioni",
      "title": "Numero di recensioni",
      "tooltip": "Quantità mensile di recensioni negli ultimi 6 mesi."
    },
    "reviewLevel": "Livello di recensioni",
    "scorePerCategory": {
      "noReviews": "Non ci sono recensioni disponibili per questa categoria.",
      "summary": "Panoramica",
      "title": "Punteggio per categoria",
      "tooltip": "Punteggio medio e informazioni utili sulle categorie più importanti per il vostro hotel."
    },
    "solo": {
      "title": "Solo",
      "tooltip": "Punteggio medio complessivo basato sugli ospiti che viaggiano da soli."
    },
    "summary": "Panoramica",
    "traveler": {
      "title": "Viaggiatore",
      "tooltip": "Distribuzione delle recensioni in base alla tipologia di viaggiatore."
    }
  },
  "resetPassword": {
    "alert": {
      "success": "Nuova password impostata. Accedi al tuo account."
    }
  },
  "save": "Salva",
  "search": "Ricerca",
  "segmentation": {
    "descriptionOne": "Questo strumento può essere utilizzato per categorizzare le prenotazioni in base ai loro segmenti. I segmenti sono specificati nel gestionale dell'Hotel / PMS e trasferiti a RateBoard. La segmentazione influenza le raccomandazioni di prezzo (Le prenotazioni complimentarie e le prenotazioni di gruppo non contano ai fini della domanda).",
    "descriptionOneNew": "Questo strumento può essere utilizzato per categorizzare le prenotazioni in base ai loro segmenti come rilevanti o non rilevanti per il calcolo della domanda. Il <b>tipo di segmentazione influisce sulla raccomandazione tariffaria, poiché le prenotazioni complementari e quelle di gruppo non vengono considerate nella domanda.</b>",
    "descriptionTwo": "Se questa funzione è attiva, ogni (nuovo) segmento deve essere mappato, la selezione della scelta 'Complementare', 'Gruppo', o 'Nessuno' è obbligatoria per ogni categoria",
    "descriptionTwoNew": "I segmenti sono gestiti nel gestionale dell'Hotel / PMS e trasferiti a RateBoard. Una volta attivata la segmentazione, <b>tutti i segmenti devono essere mappati come \"nessuno\", \"complementare\" o \"gruppo\".</b>",
    "noSegments": "Senza segmenti",
    "noSegmentsTooltip": "Impossibile attivare perché non sono presenti segmenti.",
    "tableHeaders": {
      "complimentary": "Complementare",
      "group": "Gruppo",
      "none": "Nessuno",
      "segment": "Segmenti",
      "segmentationType": "Tipo di segmentazione"
    },
    "title": "Segmentazione",
    "toggleButton": "Segmentazione attiva / disattivata"
  },
  "select": {
    "empty": "Vuoto",
    "notSet": "Non settato"
  },
  "session": {
    "expired": {
      "continue": "Utilizza RateBoard",
      "logout": "Logout",
      "message": "Non abbiamo registrato nessuna attività da qualche tempo. Per proteggere il tuo account ti scolleghiamo automaticamente fra poco. Se vuoi rimanere connesso clicca su 'Utilizza RateBoard'.",
      "title": "La sessione scade fra poco"
    }
  },
  "settings": {
    "interface": {
      "apaleo": "APALEO",
      "channelManager": {
        "add": "Crea Channel Manager",
        "addNew": "Crea CM nuovo",
        "amountOfChannelsReached": "Numero massimo di Channels raggiunto.",
        "channelManager": "Channel Manager",
        "channelNotSaved": "Channel non salvato. Impossibile di creare un nuovo Channel.",
        "configuration": "Configurazione CM",
        "importUsersNotDisabled": "Disattivare tutti gli utenti di importazione attivi o cancellare l'utente FTP corrente prima di cambiare PMS o rimuovere il canale.",
        "integration": "Integrazione",
        "integrations": "Vostre integrazioni",
        "integrationsLabel": "Integrazioni",
        "newIntegration": "Nuova integrazione CM",
        "remove": "Rimuovi channel"
      },
      "cmIntegration": "CM-Integration",
      "crawler": {
        "button": "REIMPORTARE",
        "message": "Siete sicuri di voler avviare crawler? Selezionate una nuova data di inizio o utilizzate quella predefinita (2 anni).",
        "modalTitle": "Avviare Crawler",
        "title": "CRAWLER"
      },
      "credentials": {
        "address": "API URL",
        "apiToken": "API Token",
        "connect": "Collegata",
        "disconnect": "Disconnessa",
        "disconnectMessage": "Si vuole disconnettere dall'interfaccia?",
        "errorMessageValid": "I campi sono obbligatori.",
        "hotelCode": "Hotel Code",
        "idToken": "ID Token",
        "notConnected": "Non collegata",
        "password": "Password",
        "save": "Salvare",
        "saveMessage": "Vuoi salvare le credenziali dell'interfaccia?",
        "title": "Default credentials",
        "username": "Nome utente"
      },
      "ftpCrawler": {
        "button": "REIMPORTARE",
        "message": "Siete sicuri di voler avviare ftp crawler??",
        "modalTitle": "Avviare Crawler",
        "title": "ftp crawler"
      },
      "ftpImportCredentials": {
        "generate": "Genera utente FTP",
        "title": "Ftp importazione dei dati di accesso"
      },
      "importCredentials": {
        "active": "Attivo",
        "alert": {
          "create": {
            "error": "Non è stato possibile generare un nuovo utente.",
            "success": "Nuovo utente generato."
          },
          "delete": {
            "error": "Non è stato possibile eliminare l'utente.",
            "success": "Utente cancellato."
          },
          "disable": {
            "error": "I dati di accesso non sono stati disattivati.",
            "success": "I dati di accesso sono stati disattivati."
          },
          "enable": {
            "error": "I dati di accesso non sono stati attivati.",
            "success": "I dati di accesso sono stati attivati."
          }
        },
        "disabled": "Disabili",
        "generate": "Genera utente",
        "modal": {
          "delete": "Questa azione non può essere annullata. Siete sicuri di voler eliminare l'utente {username}?",
          "disable": "Si è sicuri di voler disabilitare l'utente {username}? Questa azione blocca le importazioni con queste credenziali.",
          "generate": {
            "password": "Password",
            "title": "Nuovo utente generato",
            "username": "Nome",
            "warning": "Attenzione",
            "warningText": "La password sarà nascosta dopo questo passaggio; scrivetela prima di continuare."
          }
        },
        "newUiGenerate": "Genera utente di importazione",
        "title": "Importazione dei dati di accesso"
      },
      "inbound": {
        "generalInformation": "Informazioni generali",
        "guaranteeType": "Guarantee Type per opzioni",
        "importInventoryFromPMS": "Importare inventario dal PMS",
        "title": "Configurazione Inbound"
      },
      "interfaceConfiguration": "Configurazione Interfacce",
      "outbound": {
        "ageCategories": "Fasce di età",
        "ageQualifyingCode": "Age Qualifying Code",
        "allFieldsRequired": "I campi sono obbligatori.",
        "applyTo": "Applicare",
        "chargeType": "Tipo di addebito",
        "externalSettingsFetchingError": "Si è verificato un problema nel recupero delle tipologie di camera / dei piani tariffari dal PMS. Sono corretti i date d'accesso?",
        "generalInformation": "Informazioni generali",
        "ignored": "Ignorato",
        "maxLos": "MaxLOS",
        "mealPlan": {
          "allInclusive": "All Inclusive",
          "bedAndBreakfast": "Bed & Breakfast",
          "fullBoard": "Pensione completa",
          "halfBoard": "Mezza pensione",
          "mealType": "Meal type",
          "roomOnly": "Room Only"
        },
        "minLos": "MinLOS",
        "noActiveRatePlans": "Almeno un rate plan per interfaccia deve essere attivato.",
        "noActiveRoomTypes": "Si prega di mappare almeno una tipologia di camera.",
        "noActiveRoomTypesRatePlans": "Si prega di mappare almeno una tipologia di camera per rate plan attivato.",
        "noMappedMealPlan": "Manca la mappatura del tipo di trattamento per i piani tariffari attivati.",
        "noMappedRatePlanTitle": "Mapping per rate plan attivato non presente.",
        "noMappedRoomTypeTitle": "Nessuna topologia di camera mappata.",
        "perPerson": "Per persona",
        "perRoom": "Per camera",
        "productCode": "Product code",
        "publish": "Invio dati",
        "ratePlanCategory": "Categoria del piano tariffario",
        "ratePlanCategoryCode": "rate plan category code",
        "ratePlanCode": "rate plan code",
        "ratePlans": "Piani tariffari",
        "restrictionsSettings": "Impostazioni restrizioni",
        "roomType": "Tipo di camera",
        "roomTypes": "Tipi di camera",
        "title": "Configurazione Outbound"
      },
      "pmsConfiguration": "Configurazione PMS",
      "pmsIntegration": "PMS-Integration",
      "pmsSelection": {
        "pms": "PMS"
      },
      "restrictions": {
        "closed": "Chiuso",
        "cta": "Chiuso per arrivi (CTA)",
        "ctd": "Chiuso per partenze (CTD)",
        "maxLos": "MaxLOS",
        "minLos": "MinLOS",
        "title": "Restrizioni supportate"
      }
    },
    "inventory": {
      "capacity": {
        "addButton": {
          "newUiText": "Nuova capacità",
          "text": "Aggiungi..."
        },
        "addModal": {
          "message": "Seleziona la data di inizio della nuova capacità camere. Da questa data verrà utilizzato il numero aggiornato di camere.",
          "submit": "Aggiungi nuova capacità",
          "title": "Aggiungi capacità camere"
        },
        "cardTitle": "Capacità",
        "changeDateDialog": {
          "message": "Seleziona la nuova data di inizio da cui verrà applicata questa capacità camere.",
          "newUiTitle": "Modifica data di inizio capacità",
          "title": "Cambiare data"
        },
        "datePicker": {
          "changeDate": "Cambiare data",
          "fromLabel": "Da:",
          "label": "Data:"
        },
        "deleteImpossibleTooltipText": "Impossible cancellare impostazione. Deve esistere impostazioni per almeno 3 anni nel passato.",
        "deleteModal": {
          "message": "Sei sicuro di voler eliminare questa capacità camere? L'azione non può essere annullata.",
          "title": "Elimina capacità"
        },
        "details": "Dettagli",
        "error": {
          "collidingDate": "Esiste già una voce con la data {data}.",
          "threeYearsRequired": "È richiesto almeno un record di inventario con una data di 3 anni fa o precedente.",
          "totalAtLeastOne": "Il numero totale di stanze deve essere almeno 1."
        },
        "manualSettingNotPossible": {
          "text": "Stiamo importando le informazioni sulla capacità direttamente da PMS. La configurazione manuale della capacità è dunque disabilitata.",
          "title": "Impossibile impostare l'inventario manualmente."
        },
        "options": "Opzioni",
        "roomsAndCount": "Camere e quantità",
        "totalAvailable": {
          "label": "Totale:",
          "newUiLabel": "Camere totali:"
        }
      },
      "configuration": {
        "confirmationMessage1": "La modifica dell'assegnazione delle tipologie di camere <> categorie di camere comporta i seguenti cambiamenti nei livelli di prezzo:",
        "confirmationMessage2": "Nei livelli di prezzo con derivazioni in % dalla tipologia primaria, i valori saranno modificati TUTTI automaticamente al valore corrispondente in €.",
        "confirmationMessage3": "Se non volete procedere con questa modifica, vi preghiamo di annullare l'operazione e di contattare il nostro team di supporto all'indirizzo ",
        "confirmationMessage4": ". Nei livelli di prezzo con derivazioni in € dalla tipologia primaria, i valori impostati in € rimangono invariati.",
        "confirmationMessage5": "Vi preghiamo di controllare i valori minimi e massimi, all'interno del calendario dei livelli di prezzo, dopo il salvataggio e di modificarli se necessario.",
        "errorMessage": "Attenzione! Non tutti i campi contengono valori.",
        "options": "Opzioni",
        "pmsTitle": "Lista dei tipi dal PMS",
        "priceWarning": "La modifica di \"Tipo primario\" o \"Categoria\" può causare l'errata impostazione dei livelli di prezzo per alcune camere. Si prega di verificare le impostazioni del livello in seguito al cambio!!!",
        "roomBlocksSwitch": "Considerare blocco di gruppo",
        "roomTypeCreation": {
          "button": "Crea tipologia",
          "duplicateName": "Una tipologia di camera con questo nome esiste già, provare un nome diverso.",
          "modalContent": "Siete sicuri di creare una nuova tipologia di camera? Assicuratevi di usare un nome comprensibile.",
          "modalTitle": "Crea nuova tipologia di camera",
          "placeholder": "ROOMX"
        },
        "showExcludedRooms": "Mostra tipi esclusi",
        "table": {
          "category": "Categoria",
          "options": {
            "active": "Attivo",
            "archived": "Archiviato",
            "excluded": "Escluso",
            "header": "Opzioni"
          },
          "primary": "Primario",
          "roomType": "Tipo camera"
        },
        "unresolvableWarning": "Impossibile ricalcolare le impostazioni tariffari per i giorni seguenti: {dates}. Sovrascritture vengono cancellate. Sei sicuro di continuare?",
        "warningTitle": "ATTENZIONE!"
      },
      "tabs": {
        "capacity": "Capacità",
        "configuration": "Configurazione"
      },
      "title": "Gestione Inventario"
    },
    "notificationRules": {
      "conditions": {
        "adr": {
          "summaryAverage": "ADR è {operator} {value} per {category} in media",
          "summaryDaily": "ADR è {operator} {value} per {category} in tutti i giorni"
        },
        "autopilot": {
          "increaeOrDecrease": "aumenta o diminuisce la tariffa di oltre",
          "summary": "Autopilota aumenta o diminuisce la tariffa di oltre {deviation}"
        },
        "availability": {
          "summaryAverage": "{operator} {available} camere disponibili in media in {category}",
          "summaryDaily": "{operator} {available} camere disponibili in tutti i giorni in {category}"
        },
        "cancellation": {
          "moreThan": "Più di",
          "roomsFor": "camere cancellate negli ultimi",
          "summary": "Più di {value} camere cancellate negli ultimi {days}"
        },
        "capping": {
          "comparables": {
            "maximum": "massima",
            "minimum": "minima"
          },
          "summary": "Raggiunto il capping valore {comparable} per un periodo futuro continuo di {days}",
          "valueIsReached": "per un periodo futuro continuo di",
          "valueIsReachedAfter": "",
          "valueIsReachedBefore": "Raggiunto il"
        },
        "categoryConstraints": {
          "comparables": {
            "higher": "più",
            "lower": "meno"
          },
          "is": "è",
          "rateOf": "La tariffa di",
          "summary": "La tariffa di {categoryId1} è {comparable} a quella di {categoryId2}",
          "than": "a quella di"
        },
        "dateRange": {
          "summaryShort": "{dateFrom} - {dateTo}"
        },
        "dba": {
          "summaryShort": "{from} giorni > DBA < {to} giorni"
        },
        "occupancy": {
          "summaryAverage": "L'Occupazione è {operator} {value}% per {category} in media",
          "summaryDaily": "L'Occupazione è {operator} {value}% per {category} in tutti i giorni"
        },
        "pickup": {
          "roomsFor": "camere prenotate negli ultimi",
          "summary": "{operator} {value} camere prenotate negli ultimi {days}"
        },
        "rateLevel": {
          "undefined": "Livello di prezzo (ID={id})"
        },
        "rateRecommendation": {
          "deviatesMore": "deviano più di",
          "fromTheActive": "dalla tariffa attiva.",
          "summary": "Suggerimenti prezzo deviano più di {deviation} dalla tariffa attiva"
        },
        "revpar": {
          "summaryAverage": "Il RevPAR è {operator} {value} per {category} in media",
          "summaryDaily": "Il RevPAR è {operator} {value} per {category} in tutti i giorni"
        },
        "types": {
          "autopilot": "Autopilota",
          "cancellation": "Cancellazione",
          "capping": "Capping",
          "categoryConstraints": "Vincoli categoria",
          "pickup": "Pickup",
          "rateRecommendation": "Suggerimenti prezzo",
          "yoyComparison": "Anno precedente"
        },
        "yoyComparison": {
          "are": "sono",
          "comparables": {
            "higher": "aumentate",
            "lower": "diminuite"
          },
          "compareTo": "Confronta con",
          "comparisonDays": {
            "sameDate": "stessa data",
            "sameWeekday": "stesso giorno della settimana"
          },
          "dataTypes": {
            "adr": "ADR",
            "availability": "Camere Vuote",
            "booking": "Prenotazioni",
            "cancellations": "Cancellazioni",
            "occupancy": "Occupazione",
            "pickup": "Pickup",
            "revenue": "OTB Revenue",
            "revPar": "RevPar"
          },
          "is": "è",
          "summaryAverage": "{dataType} {isOrAre} {deviation} {comparable} in media rispetto all'anno precedente. Confronta con {comparisonDay}",
          "summaryAveragePickupOrCancellation": "{dataType} {isOrAre} {deviation} {comparable} in media rispetto all'anno scorso negli ultimi {days}. Confronta con {comparisonDay}",
          "summaryDaily": "{dataType} {isOrAre} {deviation} {comparable} in tutti i giorni rispetto all'anno precedente. Confronta con {comparisonDay}",
          "summaryDailyPickupOrCancellation": "{dataType} {isOrAre} {deviation} {comparable} in tutti i giorni rispetto all'anno scorso negli ultimi {days}. Confronta con {comparisonDay}",
          "thanLastYear": "rispetto all'anno.",
          "thanLastYearForARunningPeriodOf": "rispetto all'anno scorso negli ultimi"
        }
      },
      "createRule": "Nuova notifica",
      "createRuleNew": "Nuova Notifica",
      "days": "{n} giorni",
      "deleteRule": {
        "title": "Eliminata notifica"
      },
      "description": "Crea notifiche personalizzate per questo hotel, esclusive per il tuo account—attiva fino a {n} contemporaneamente. ",
      "editCreateRule": {
        "conditions": {
          "summary": "Se le seguenti condizioni ...",
          "title": "Condizioni ({n}/{max})",
          "titleTooltip": "Combina fino a {n} condizioni. La notifica si attiva quando tutte le condizioni sono soddisfatte."
        },
        "createRule": "Nuova Notifica",
        "editRule": "Modifica Notifica",
        "invalidTimeRange": "Deve essere impostato almeno un DBA o un intervallo di date",
        "notificationType": {
          "summary": "notificami via",
          "title": "Tipo di notifica",
          "titleTooltip": "Scegli di essere notificato tramite l´app nel Dashboard o via e-mail."
        },
        "ruleName": "Nome della notifica",
        "ruleNameTooltip": "Puoi rinominare la notifica in seguito. Scegli un nome che descriva chiaramente il suo scopo.",
        "summaryLabels": {
          "for": "Per",
          "if": "Se"
        },
        "timeRange": {
          "add": "Aggiungi intervallo di tempo",
          "summary": "si applicano durante questo periodo ...",
          "title": "Intervallo di tempo ({n}/{max})",
          "titleTooltip": "Deve essere aggiunto almeno DBA o Intervallo di date. Opzioni di intervallo di tempo dello stesso tipo non possono essere combinate."
        },
        "valueProvingType": {
          "buttonTemplate": "Valori {type}",
          "label": "Tipo di valutazione",
          "labelTooltip": "Scegli se valutare ogni giorno individualmente o utilizzare la media per l’intervallo di tempo selezionato."
        }
      },
      "notificationRuleTable": {
        "actions": "Azioni",
        "conditions": "Condizioni",
        "conditionsAmountString": "{n}/{max}",
        "name": "Nome della notifica",
        "notificationTypes": "Tipo di notifica",
        "status": "Stato",
        "statusTooltip": "Puoi avere fino a {n} regole attive",
        "timeRangeConditions": "Intervallo di tempo",
        "tooltip": {
          "delete": "Rimuovere la regola",
          "edit": "Modifica regola",
          "ruleActive": "Regola attiva",
          "ruleInactive": "Regola inattiva"
        }
      },
      "notificationTypes": {
        "types": {
          "dashboard": "In-app",
          "email": "E-mail"
        },
        "undefined": {
          "summary": "Non è ancora stato impostato un tipo di notifica"
        }
      },
      "timeRanges": {
        "dateRange": {
          "exceeded": "L’intervallo di date di questa notifica è scaduto. Si prega di aggiornarlo per ricevere notifiche."
        },
        "undefined": {
          "summary": "Non è ancora stato fissato un intervallo di tempo"
        }
      },
      "title": "Notifiche",
      "toast": {
        "activationFailed": "Non siamo riusciti ad attivare questa notifica. Ti preghiamo di riprovare più tardi o di contattare il nostro team di supporto se il problema persiste.",
        "activationOk": "La notifica è stata attivata.",
        "changesFailed": "Non siamo riusciti a salvare le modifiche. Ti preghiamo di riprovare più tardi o di contattare il nostro team di supporto se il problema persiste.",
        "changesOk": "Le tue modifiche sono state salvate.",
        "deactivationFailed": "Non siamo riusciti a disattivare questa notifica. Ti preghiamo di riprovare più tardi o di contattare il nostro team di supporto se il problema persiste.",
        "deactivationOk": "La notifica è stata disattivata.",
        "deleteFailed": "Non siamo riusciti a eliminare questa notifica. Ti preghiamo di riprovare più tardi o di contattare il nostro team di supporto se il problema persiste.",
        "deleteOk": "La notifica è stata eliminata.",
        "maxActive": "Hai raggiunto il limite di {n} regole attive. Disattiva una regola esistente prima di attivare questa."
      },
      "valueProvingTypes": {
        "types": {
          "average": "medio",
          "daily": "giornalieri"
        }
      }
    },
    "rateRounding": {
      "methods": {
        "up": "Arrotondare a",
        "up_down": "Arrotondare o scendere a",
        "up_down_multiples": "Arrotondare o scendere a multipli di",
        "up_multiples": "Arrotondare a multipli di"
      },
      "noRounding": "Non arrotondare",
      "title": "Arrotondare la tariffa"
    },
    "rateRules": {
      "actions": {
        "directions": {
          "decrease": "riduzione",
          "increase": "incremento"
        },
        "rate": {
          "rateBy": "della tariffa di",
          "summary": "{direction} della tariffa di {value} per {category}"
        },
        "undefined": {
          "summary": "Nessuna azione definita"
        }
      },
      "category": {
        "allCategories": "tutte le categorie",
        "customCategory": "Categorie (ID={id})",
        "for": "per"
      },
      "computeRecommendations": "Calcolare suggerimenti",
      "conditions": {
        "adr": {
          "summary": "ADR è {operator} {value} per {category}"
        },
        "are": "sono",
        "availability": {
          "areVacantFor": "sono disponibili per",
          "rooms": "camere vuote",
          "summary": "{comparable} {available} camere vuote sono disponibili per {category}"
        },
        "competitors": {
          "comparables": {
            "average": "medie",
            "highest": "più alte",
            "lowest": "più basse"
          },
          "mine": "alla mia.",
          "ratesOf": "Le tariffe",
          "summary": "Le tariffe {comparable} di {category} di tutti i concorrenti sono {offset}{operator} alla mia"
        },
        "dateRange": {
          "maxDiffTooltip": "L'intervallo non può superare un intervallo di {n} giorni.",
          "summary": "L'intervallo di date va da {dateFrom} a {dateTo}"
        },
        "dba": {
          "and": "e",
          "fromHigherTo": "Il limite inferiore di DBA non può essere superiore al limite massimo di DBA.",
          "isBetween": "è tra",
          "maxDbaDiffExceeded": "L'intervallo DBA non può superare un intervallo di {n} giorni.",
          "maxDbaExceeded": "Questa condizione può essere valutata fino a {n} giorni.",
          "maxDbaTooltip": "Il tempo da valutare può arrivare fino a {n} giorni nel futuro.",
          "summary": "Il DBA è tra {from} e {to} giorni"
        },
        "event": {
          "notSet": "non impostato",
          "onTheDate": "sul giorno scelto.",
          "set": "impostato",
          "summary": "L'evento è {set} sul giorno scelto"
        },
        "is": "è",
        "occupancy": {
          "summary": "L'Occupazione è {operator} {occupancy}% per {category}"
        },
        "of": "di",
        "rateLevel": {
          "isActiveFor": "è attivo per",
          "summary": "Il livello di prezzo '{rateLevel}' è attivo per {category}"
        },
        "revPar": {
          "summary": "Il RevPAR è {operator} a {revPar} per {category}"
        },
        "types": {
          "adr": "ADR (Average Daily Rate)",
          "availability": "Camere vuote",
          "competitors": "Concorrenti",
          "dateRange": "Intervallo di date",
          "dba": "DBA (Days Before Arrival)",
          "event": "Eventi",
          "occupancy": "Occupazione",
          "rateLevel": "Livello di prezzo",
          "revPar": "RevPAR (Revenue per available room)",
          "weatherForecast": "Previsioni meteo",
          "weatherTemperature": "Temperatura",
          "weatherWindSpeed": "Velocità del vento",
          "weekday": "Giorno della settimana"
        },
        "undefined": {
          "summary": "Non è ancora stata stabilita alcuna condizione"
        },
        "weatherForecast": {
          "comparables": {
            "cloudy": "nuvoloso",
            "misty": "variabile",
            "rainy": "pioggia",
            "snowy": "neve",
            "sunny": "sole"
          },
          "onAffectedDay": "il giorno interessato.",
          "summary": "Le previsioni meteo danno {comparable} il giorno interessato"
        },
        "weatherTemperature": {
          "comparables": {
            "average": "media",
            "maximum": "massima",
            "minimum": "minima"
          },
          "summary": "La temperatura {comparable} è {operator} {temperature}",
          "temperatureIs": "temperatura è"
        },
        "weatherWindSpeed": {
          "summary": "Velocità del vento è {operator} {windSpeed}",
          "windSpeedIs": "Velocità del vento è"
        },
        "weekday": {
          "summaryMany": "I giorni feriali sono {weekdays} e {lastWeekday}",
          "summaryOne": "Il giorno feriale è il {weekday}"
        }
      },
      "createRule": "Nuova regola",
      "createRuleNew": "Nuova regola prezzi",
      "deleteRule": {
        "message": "Questa azione non può essere annullata! Sei sicuro di voler rimuovere questa regola?",
        "title": "Rimuovere la regola"
      },
      "description": "Crea regole per adattare i suggerimenti prezzo del tuo hotel. Le regole vengono applicate alle raccomandazioni calcolate dall’algoritmo.",
      "descriptionTwo": "È possibile attivare fino a {n} regole.",
      "editCreateRule": {
        "actions": {
          "add": "Aggiungi azione",
          "summary": "... eseguire le seguenti azioni:",
          "title": "Azioni",
          "titleTooltip": "Aggiungi fino a {n} azioni alla regola. Se le condizioni sono soddisfatte, tutte le azioni verranno eseguite."
        },
        "conditions": {
          "add": "Aggiungi condizione",
          "none": "Nessuno",
          "summary": "Se si applicano le seguenti condizioni ...",
          "title": "Condizioni",
          "titleTooltip": "Aggiungi fino a {n} condizioni alla regola. Tutte le condizioni devono essere soddisfatte affinché le azioni possano essere eseguite."
        },
        "createRule": "Creare una nuova regola",
        "editRule": "Modifica regola",
        "invalid": "Per salvare una regola sono necessari almeno un nome, una condizione ed un'azione. È possibile aggiungere un massimo di {nC} condizioni e {nA} azioni.",
        "ruleName": "Nome della regola",
        "ruleNameTooltip": "È possibile modificare il nome della regola in un secondo momento. Scegliere un nome che descriva chiaramente la nuova regola.",
        "summary": "sommario"
      },
      "hotelOrCategory": {
        "category": "Categoria camera",
        "hotel": "Hotel"
      },
      "operators": {
        "equalTo": "uguale a",
        "lessThan": "inferiore a",
        "moreThan": "superiore a",
        "noLessThan": "non inferiore a",
        "noMoreThan": "non superiore a"
      },
      "rateRule": {
        "accumulating": {
          "description": "Tutte le regole di questa sezione sono attive e vengono eseguite in quanto le condizioni risultano adempite.",
          "title": "Regole cumulative"
        },
        "activeSince": "Attivo da {dateTime}",
        "and": "e",
        "create": "creare",
        "hierarchical": {
          "description": "Tutte le regole di questa sezione sono attive. Le regole sono controllate in ordine gerarchico. L'ordine può essere modificato mediante trascinamento. Viene applicata la prima regola che soddisfa le condizioni. Tutte le regole successive vengono saltate.",
          "title": "Regole gerarchiche"
        },
        "inactive": {
          "description": "In quest'area vengono salvate sia le regole nuove che quelle inattive. Trascinare una regola nell'area desiderata (cumulativa o gerarchica) per attivarla. Trascinare nuovamente la regola in quest'area per disattivarla.",
          "title": "Regole inattive"
        },
        "nActions": "{n} azioni|{n} azione|{n} azioni",
        "nConditions": "{n} condizioni|{n} condizione|{n} condizioni",
        "notDraggable": "Raggiunto il numero massimo di regole attive"
      },
      "rateRuleContainer": {
        "order": "{order}°"
      },
      "title": "Regole Prezzi",
      "toast": {
        "computationRequestOk": "I consigli vengono calcolati. Potrebbero volerci un paio di minuti."
      }
    }
  },
  "sidebar": {
    "emptyPlaceHolder": "Non c'è niente da visualizzare qui!"
  },
  "termsOfUse": {
    "message": "Prima di utilizzare RateBoard, leggi e accetta i nostri Termini di utilizzo e l’Informativa sulla privacy. Puoi trovarli qui:",
    "messageNew": "Prima di utilizzare RateBoard, leggi e accetta i nostri Termini di utilizzo e l'Informativa sulla privacy.",
    "title": "Termini di Utilizzo"
  },
  "userSettings": {
    "accountSettings": {
      "defaultCompany": "Apri all'avvio",
      "defaultCompanyTooltip": "Selezionare una proprietà predefinita da visualizzare all'avvio di RateBoard.",
      "language": "Linguaggio",
      "locale": "Formattazione",
      "locales": {
        "AT": "Austriaco",
        "CH": "Svizzero",
        "DE": "Tedesco",
        "FI": "Finlandese",
        "FR": "Francese",
        "GB": "Inglese (GB)",
        "IT": "Italiano",
        "US": "Inglese (US)"
      },
      "localeTooltip": "Il formato della data e della valuta vengono impostati in base alla regione selezionata. Ciò non influisce sulla regione della proprietà.",
      "title": "Impostazioni dell account"
    },
    "changePassword": {
      "confirmPassword": "Ripeti password",
      "confirmPasswordPlaceholder": "Ripeti password",
      "invalidOld": "Password vecchia errata!",
      "newPassword": "Nuova password",
      "newPasswordPlaceholder": "Nuova password",
      "notMatching": "La password ripetuta è differente!",
      "oldPassword": "Password vecchia",
      "oldPasswordPlaceholder": "Password",
      "save": "Salva la nuova password",
      "subtitle": "Cambia la password",
      "title": "Cambia la password",
      "titleNew": "Cambiare la password",
      "tooShort": "Password errata! La password deve essere lunga almeno 8 caratteri e può contenere caratteri speciali, ma non spazi."
    },
    "overview": "Quadro generale",
    "reports": {
      "frequency": {
        "DAILY": "Giornaliero",
        "MONTHLY": "Mensile",
        "NEVER": "Mai",
        "WEEKLY": "Settimanale"
      },
      "performanceReport": "Performance Report",
      "pickupReport": "Pickup Report",
      "rateReport": "Rate Report",
      "title": "Rapporti"
    },
    "resetPassword": {
      "title": "Reimposta la password"
    },
    "saveChanges": "Salvare le modifiche",
    "savePassword": "Cambia password",
    "security": "Impostazioni di sicurezza",
    "title": "User Settings",
    "twoFactorAuthentication": {
      "addDevice": "Aggiungi dispositivo",
      "addDeviceError": "Il dispositivo 2FA non può essere aggiunto.",
      "addDeviceSuccess": "Dispositivo 2FA aggiunto con successo.",
      "disabled": "Inattivo",
      "enabled": "Attivo ",
      "otpInputField": "Codice a 6 cifre",
      "otpInvalid": "Codice non valido, riprovare",
      "otpMessage": "Inserire il codice dell'app di autenticazione per verificare che tutto sia impostato correttamente. Una volta stabilita la connessione, il dispositivo verrà salvato in modo da poter essere utilizzato al momento dell'accesso.",
      "otpTitle": "Verifica dell'app di autenticazione",
      "password": "Password",
      "passwordInvalid": "La password non è corretta, si prega di riprovare",
      "qrCodeAccountName": "Nome del conto: ",
      "qrCodeManual": "Oppure inserite manualmente il codice nella vostra app di verifica",
      "qrCodeManualCode": "Codice: ",
      "qrCodeMessage": "Eseguire la scansione del codice QR con un'applicazione di sicurezza o di autenticazione come Google Authenticator, Authy, Duo o un altro strumento affidabile disponibile nell'app store del dispositivo.",
      "qrCodeTitle": "Eseguire la scansione del codice QR con l'app di autenticazione",
      "removeDevice": "Rimuovi dispositivo",
      "removeDeviceError": "Il dispositivo 2FA non può essere rimosso.",
      "removeDeviceMessage": "Inserire la password per disattivare e rimuovere il dispositivo. Questa azione non può essere interrotta, ma è possibile aggiungere un nuovo dispositivo in un secondo momento.",
      "removeDeviceSuccess": "Il dispositivo 2FA è stato rimosso e disattivato con successo.",
      "removeDeviceTitle": "Rimuovere l'autenticazione a due fattori",
      "setupMessage": "Inserire la password di RateBoard per avviare la configurazione.",
      "setupTitle": "Impostazione dell'autenticazione a due fattori",
      "title": "Autenticazione a due fattori",
      "tooltip": "È possibile collegare al massimo un dispositivo"
    },
    "user": {
      "title": "User Settings",
      "userMail": "User E-Mail"
    }
  },
  "validation": {
    "max": "Superato il numero massimo di caratteri",
    "min": "Il numero di caratteri inseriti è inferiore al minimo richiesto",
    "required": "Richiesto"
  },
  "warning": {
    "warning": "Attenzione!",
    "warningDeletion": "Quest'azione è irreversibile. Sei sicuro di voler continuare?",
    "warningUnsavedChanges": "Ci sono ancora modifiche non salvate. Se continua le modifiche vanno perse."
  },
  "yes": "Si"
}
